import React, { useEffect, useState, useRef } from 'react';
import { useFormik } from 'formik';
import { FaChevronUp, FaFilePdf } from "react-icons/fa";
import Loader from '../../../../../components/Loader/Loader';
import SelectFild from '../../../../../components/SelectFild/SelectFild';
import DateFild from '../../../../../components/DateTimePicker/DateFild';
import { Row, Col } from 'react-bootstrap';

import UploadWithSignature from '../../../../../components/UploadWithSignature/UploadWithSignature';

import bodyL from '../../../../../assets/images/bodyL.jpg';
import bodyR from '../../../../../assets/images/bodyR.jpg';
import womenbodyL from '../../../../../assets/images/womenbodyL.jpg';
import womenbodyR from '../../../../../assets/images/womenbodyR.jpg';

import { postWhatOccurredStore } from '../../../../../apiservices/ApiServices';


import SignaturePad from 'signature_pad';
import carImg from '../../../../../assets/images/car.png';

const CarParkCurbsideIncident = ({ details, selectedCheckboxes, postUpdateData, toast }) => {
    const [isLoadings, setLoadings] = useState(false);
    const [preImg, setPreImg] = useState([]);
    const [uploadedFiles, setUploadedFiles] = useState([]);
    const [personInvolvedItems, setPersonInvolvedItems] = useState([]);
    const [injuryOutcomeItems, setInjuryOutcomeItems] = useState([]);
    const [subChkLists, setSubChkLists] = useState([]);

    const [signatureImg, setSignatureImg] = useState('');
    const canvasRef = useRef(null);
    const signaturePadRef = useRef(null);

    useEffect(() => {
        const canvas = canvasRef.current;
        initializeCanvas(canvas);

        window.addEventListener('resize', handleResize);

        return () => {
            window.removeEventListener('resize', handleResize);
        };
    }, []);

    const initializeCanvas = (canvas) => {
        // Set display size (CSS pixels)
        const displayWidth = 270;
        const displayHeight = 431;

        // Set actual size in memory (scaled to account for extra pixel density)
        const scale = window.devicePixelRatio || 1;
        canvas.width = displayWidth * scale;
        canvas.height = displayHeight * scale;

        // Normalize coordinate system to use CSS pixels
        canvas.style.width = `${displayWidth}px`;
        canvas.style.height = `${displayHeight}px`;

        const ctx = canvas.getContext('2d');
        ctx.scale(scale, scale);

        signaturePadRef.current = new SignaturePad(canvas, {
            backgroundColor: 'white',
            penColor: 'rgb(255, 0, 0)'
        });

        // Load car image
        const img = new Image();
        img.src = carImg;
        img.onload = () => {
            ctx.drawImage(img, 0, 0, displayWidth, displayHeight);
        };
    };

    const handleResize = () => {
        const canvas = canvasRef.current;
        if (!canvas) return;

        // Save current signature
        const data = signaturePadRef.current.toDataURL();

        // Reinitialize canvas
        initializeCanvas(canvas);

        // Restore signature
        if (data !== carImg) {
            signaturePadRef.current.fromDataURL(data);
        }
    };

    const clearSignature = () => {
        if (signaturePadRef.current) {
            signaturePadRef.current.clear(); // clear SignaturePad strokes

            const canvas = canvasRef.current;
            const ctx = canvas.getContext('2d');

            // Clear canvas pixels
            ctx.clearRect(0, 0, canvas.width, canvas.height);

            // Redraw car image
            const img = new Image();
            img.src = carImg;
            img.onload = () => {
                const displayWidth = parseInt(canvas.style.width);
                const displayHeight = parseInt(canvas.style.height);
                ctx.drawImage(img, 0, 0, displayWidth, displayHeight);
            };

            setSignatureImg('');
        }
    };

    const dataURLToBlob = (dataURL) => {
        const parts = dataURL.split(';base64,');
        const contentType = parts[0].split(":")[1];
        const raw = window.atob(parts[1]);
        const rawLength = raw.length;
        const uInt8Array = new Uint8Array(rawLength);

        for (let i = 0; i < rawLength; ++i) {
            uInt8Array[i] = raw.charCodeAt(i);
        }

        return new Blob([uInt8Array], { type: contentType });
    };



    useEffect(() => {
        let sublist = selectedCheckboxes["10"];
        setSubChkLists(sublist);
    }, [selectedCheckboxes]);

    const personInvolvedChkItems = [
        "passenger",
        "staff",
        "contractor",
        "other",
    ];

    const injuryOutcomeChkItems = [
        "first aid",
        "hospitalized",
        "fatal",
        "other",
    ];

    const createEmptyEntry = (type) => {
        const baseFields = {
            date: '',
            dateofPainOnset: '',
            frequencyAndDurationofPain: '',

            painLocations: [],
            painDescriptions: [],
            painIntensity: [],
            otherSymptoms: '',

            FpainLocations: [],
            FpainDescriptions: [],
            FpainIntensity: [],
            FotherSymptoms: '',
        };

        switch (type) {
            case 'passenger':
                return {
                    ...baseFields,
                    type: 'passenger',
                    passengerName: '',
                    passportNumber: '',
                };
            case 'staff':
                return {
                    ...baseFields,
                    type: 'staff',
                    staffName: '',
                    staffId: '',
                };
            case 'contractor':
                return {
                    ...baseFields,
                    type: 'contractor',
                    contractorName: '',
                    contractorId: '',
                };
            case 'other':
                return {
                    ...baseFields,
                    type: 'other',
                    patientName: '',
                    patientIdentit: '',
                };
            default:
                return baseFields;
        }
    };

    const handlePersonInvolvedItemsChange = (event) => {
        const { value, checked } = event.target;
        if (checked) {
            setPersonInvolvedItems((prev) => [...prev, value]);
            if (values[value].length === 0) {
                const emptyEntry = createEmptyEntry(value);
                setFieldValue(value, [emptyEntry]);
            }
        } else {
            setPersonInvolvedItems((prev) => prev.filter((item) => item !== value));
        }
    };

    const handleinjuryOutcomeItemsChange = (event) => {
        const { value, checked } = event.target;
        if (checked) {
            setInjuryOutcomeItems((prev) => [...prev, value]);
        } else {
            setInjuryOutcomeItems((prev) => prev.filter((item) => item !== value));
        }
    };

    const initialValues = {
        what_occurred_detail_id: '',
        personInvolved: [],
        injuryOutcome: [],
        driverName: '',
        driverLicenseDetails: '',
        vehicleDetails: '',
        numberOfVehiclesInvolved: '',
        speedOfVehicle: '',
        insuranceDetails: '',

        passenger: [],
        staff: [],
        contractor: [],
        other: [],

        collision: {
            collisionType: '',
            damageDescription: '',
            anyFluidsSpilled: '',
            towTruckRequired: '',
        },
        pedestrian: {
            pedestrianName: '',
            pedestrianContact: '',
            wasTheAreaAdequatelyLit: '',
        },
        fire: {
            fireLocation: '',
            fireAlarmActivated: '',
            fireExtinguishedBeforeArrival: '',
            fireServiceCalled: '',
            suspectedCause: '',
        },

        remark: '',
    };

    const addPassenger = () => {
        const emptyEntry = createEmptyEntry('passenger');
        setFieldValue('passenger', [...values.passenger, emptyEntry]);
    };

    const removePassenger = (index) => {
        const updated = values.passenger.filter((_, i) => i !== index);
        setFieldValue('passenger', updated);
    };

    const addStaff = () => {
        const emptyEntry = createEmptyEntry('staff');
        setFieldValue('staff', [...values.staff, emptyEntry]);
    };

    const removeStaff = (index) => {
        const updated = values.staff.filter((_, i) => i !== index);
        setFieldValue('staff', updated);
    };

    const addContractor = () => {
        const emptyEntry = createEmptyEntry('contractor');
        setFieldValue('contractor', [...values.contractor, emptyEntry]);
    };

    const removeContractor = (index) => {
        const updated = values.contractor.filter((_, i) => i !== index);
        setFieldValue('contractor', updated);
    };

    const addOther = () => {
        const emptyEntry = createEmptyEntry('other');
        setFieldValue('other', [...values.other, emptyEntry]);
    };

    const removeOther = (index) => {
        const updated = values.other.filter((_, i) => i !== index);
        setFieldValue('other', updated);
    };

    useEffect(() => {
        const detailItem = details?.what_occurred?.details?.["10"]?.[0];
        if (detailItem) {
            const commonfield = JSON.parse(detailItem.data_json)?.[0] || {};
            const healthIncidents = detailItem.health_incidents || {};

            // Set common fields
            setPreImg(detailItem.image_json || []);
            setPersonInvolvedItems(commonfield.personInvolved || []);
            setInjuryOutcomeItems(commonfield.injuryOutcome || []);

            // Initialize form values
            const initialFormValues = {
                ...initialValues,
                what_occurred_detail_id: detailItem.id || '',
                driverName: commonfield.driverName || '',
                driverLicenseDetails: commonfield.driverLicenseDetails || '',
                vehicleDetails: commonfield.vehicleDetails || '',
                numberOfVehiclesInvolved: commonfield.numberOfVehiclesInvolved || '',
                speedOfVehicle: commonfield.speedOfVehicle || '',
                insuranceDetails: commonfield.insuranceDetails || '',

                collision: {
                    collisionType: commonfield.collision?.collisionType || '',
                    damageDescription: commonfield.collision?.damageDescription || '',
                    anyFluidsSpilled: commonfield.collision?.anyFluidsSpilled || '',
                    towTruckRequired: commonfield.collision?.towTruckRequired || '',
                },
                pedestrian: {
                    pedestrianName: commonfield.pedestrian?.pedestrianName || '',
                    pedestrianContact: commonfield.pedestrian?.pedestrianContact || '',
                    wasTheAreaAdequatelyLit: commonfield.pedestrian?.wasTheAreaAdequatelyLit || '',
                },
                fire: {
                    fireLocation: commonfield.fire?.fireLocation || '',
                    fireAlarmActivated: commonfield.fire?.fireAlarmActivated || '',
                    fireExtinguishedBeforeArrival: commonfield.fire?.fireExtinguishedBeforeArrival || '',
                    fireServiceCalled: commonfield.fire?.fireServiceCalled || '',
                    suspectedCause: commonfield.fire?.suspectedCause || '',
                },

                remark: commonfield.remark || '',
            };

            // Process passenger data
            if (healthIncidents.passenger) {
                initialFormValues.passenger = healthIncidents.passenger.map(passenger => {
                    const humanDetails = JSON.parse(passenger.human_details_json);
                    const humanData = JSON.parse(passenger.human_json);
                    return {
                        type: 'passenger',
                        id: passenger.id || '',
                        passengerName: humanDetails.passenger_name || '',
                        passportNumber: humanDetails.passport_no || '',
                        date: humanDetails.date || '',
                        dateofPainOnset: humanDetails.date_of_pain_onset || '',
                        frequencyAndDurationofPain: humanDetails.frequency_duration_of_pain || '',
                        gender: humanDetails.gender || [],

                        painLocations: humanData.painLocations || [],
                        painDescriptions: humanData.painDescriptions || [],
                        painIntensity: humanData.painIntensity || [],
                        otherSymptoms: humanData.otherSymptoms || '',

                        FpainLocations: humanData.FpainLocations || [],
                        FpainDescriptions: humanData.FpainDescriptions || [],
                        FpainIntensity: humanData.FpainIntensity || [],
                        FotherSymptoms: humanData.FotherSymptoms || '',
                    };
                });
            }

            // Process staff data
            if (healthIncidents.staff) {
                initialFormValues.staff = healthIncidents.staff.map(staff => {
                    const humanDetails = JSON.parse(staff.human_details_json);
                    const humanData = JSON.parse(staff.human_json);
                    return {
                        type: 'staff',
                        id: staff.id || '',
                        staffName: humanDetails.staffName || '',
                        staffId: humanDetails.staff_id || '',
                        date: humanDetails.date || '',
                        dateofPainOnset: humanDetails.date_of_pain_onset || '',
                        frequencyAndDurationofPain: humanDetails.frequency_duration_of_pain || '',
                        gender: humanDetails.gender || [],

                        painLocations: humanData.painLocations || [],
                        painDescriptions: humanData.painDescriptions || [],
                        painIntensity: humanData.painIntensity || [],
                        otherSymptoms: humanData.otherSymptoms || '',

                        FpainLocations: humanData.FpainLocations || [],
                        FpainDescriptions: humanData.FpainDescriptions || [],
                        FpainIntensity: humanData.FpainIntensity || [],
                        FotherSymptoms: humanData.FotherSymptoms || '',
                    };
                });
            }

            // Process contractor data
            if (healthIncidents.contractor) {
                initialFormValues.contractor = healthIncidents.contractor.map(contractor => {
                    const humanDetails = JSON.parse(contractor.human_details_json);
                    const humanData = JSON.parse(contractor.human_json);
                    return {
                        type: 'contractor',
                        id: contractor.id || '',
                        contractorName: humanDetails.contractorName || '',
                        contractorId: humanDetails.contractor_id || '',
                        date: humanDetails.date || '',
                        dateofPainOnset: humanDetails.date_of_pain_onset || '',
                        frequencyAndDurationofPain: humanDetails.frequency_duration_of_pain || '',
                        gender: humanDetails.gender || [],

                        painLocations: humanData.painLocations || [],
                        painDescriptions: humanData.painDescriptions || [],
                        painIntensity: humanData.painIntensity || [],
                        otherSymptoms: humanData.otherSymptoms || '',

                        FpainLocations: humanData.FpainLocations || [],
                        FpainDescriptions: humanData.FpainDescriptions || [],
                        FpainIntensity: humanData.FpainIntensity || [],
                        FotherSymptoms: humanData.FotherSymptoms || '',
                    };
                });
            }

            // Process other data
            if (healthIncidents.other) {
                initialFormValues.other = healthIncidents.other.map(other => {
                    const humanDetails = JSON.parse(other.human_details_json);
                    const humanData = JSON.parse(other.human_json);
                    return {
                        type: 'other',
                        id: other.id || '',
                        patientName: humanDetails.patientName || '',
                        patientIdentit: humanDetails.patientIdentit || '',
                        date: humanDetails.date || '',
                        dateofPainOnset: humanDetails.date_of_pain_onset || '',
                        frequencyAndDurationofPain: humanDetails.frequency_duration_of_pain || '',
                        gender: humanDetails.gender || [],

                        painLocations: humanData.painLocations || [],
                        painDescriptions: humanData.painDescriptions || [],
                        painIntensity: humanData.painIntensity || [],
                        otherSymptoms: humanData.otherSymptoms || '',

                        FpainLocations: humanData.FpainLocations || [],
                        FpainDescriptions: humanData.FpainDescriptions || [],
                        FpainIntensity: humanData.FpainIntensity || [],
                        FotherSymptoms: humanData.FotherSymptoms || '',
                    };
                });
            }

            formik.setValues(initialFormValues);
        }
    }, [details]);

    const transformFormValuesToPostData = (values) => {
        let signatureBlob = null;

        if (signaturePadRef.current && !signaturePadRef.current.isEmpty()) {
            const signatureDataUrl = canvasRef.current.toDataURL('image/png');
            signatureBlob = dataURLToBlob(signatureDataUrl);
            setSignatureImg(signatureDataUrl);
        }

        const selectedCatList = JSON.stringify(selectedCheckboxes);

        const formData = new FormData();
        formData.append('category_data', selectedCatList);

        formData.append('what_occurred_detail_id', details?.what_occurred?.details?.["10"]?.[0]?.id || '');
        formData.append('incident_header_id', details.header_id);
        const main_category = 10;
        const sub_category = selectedCheckboxes["10"];
        formData.append('category_id', main_category);

        formData.append('what_occurred_header_id', details?.what_occurred?.id);
        formData.append('sub_category_id', JSON.stringify(sub_category));

        let param = {
            personInvolved: personInvolvedItems,
            injuryOutcome: injuryOutcomeItems,

            driverName: values.driverName || '',
            driverLicenseDetails: values.driverLicenseDetails || '',
            vehicleDetails: values.vehicleDetails || '',
            numberOfVehiclesInvolved: values.numberOfVehiclesInvolved || '',
            speedOfVehicle: values.speedOfVehicle || '',
            insuranceDetails: values.insuranceDetails || '',

            ...(subChkLists.includes(37) && {
                collision: {
                    collisionType: values.collision?.collisionType || '',
                    damageDescription: values.collision?.damageDescription || '',
                    anyFluidsSpilled: values.collision?.anyFluidsSpilled || '',
                    towTruckRequired: values.collision?.towTruckRequired || '',
                },
            }),

            ...(subChkLists.includes(38) && {
                pedestrian: {
                    pedestrianName: values.pedestrian?.pedestrianName || '',
                    pedestrianContact: values.pedestrian?.pedestrianContact || '',
                    wasTheAreaAdequatelyLit: values.pedestrian?.wasTheAreaAdequatelyLit || '',
                },
            }),

            ...(subChkLists.includes(39) && {
                fire: {
                    fireLocation: values.fire?.fireLocation || '',
                    fireAlarmActivated: values.fire?.fireAlarmActivated || '',
                    fireExtinguishedBeforeArrival: values.fire?.fireExtinguishedBeforeArrival || '',
                    fireServiceCalled: values.fire?.fireServiceCalled || '',
                    suspectedCause: values.fire?.suspectedCause || '',
                },
            }),

            remark: values.remark || '',
        };

        const data_json = [];
        data_json.push(param);
        formData.append('data_json', JSON.stringify(data_json));

        const data_jsons = [];

        const mapCategoryItems = (items, type) => {
            return items.map((item) => {
                const base = {
                    type: type.charAt(0).toUpperCase() + type.slice(1),
                    id: item.id,
                    date: item.date,
                    date_of_pain_onset: item.dateofPainOnset,
                    frequency_duration_of_pain: item.frequencyAndDurationofPain,
                    gender: item.gender,
                    body_part_pain: {
                        painLocations: item.painLocations,
                        painDescriptions: item.painDescriptions,
                        painIntensity: item.painIntensity,
                        otherSymptoms: item.otherSymptoms,

                        FpainLocations: item.FpainLocations,
                        FpainDescriptions: item.painDescriptions,
                        FpainIntensity: item.FpainIntensity,
                        FotherSymptoms: item.FotherSymptoms,
                    }
                };

                if (type === 'passenger') {
                    base.passenger_name = item.passengerName;
                    base.passport_no = item.passportNumber;
                } else if (type === 'staff') {
                    base.staffName = item.staffName;
                    base.staff_id = item.staffId;
                } else if (type === 'contractor') {
                    base.contractorName = item.contractorName;
                    base.contractor_id = item.contractorId;
                } else if (type === 'other') {
                    base.patientName = item.patientName;
                    base.patientIdentit = item.patientIdentit;
                }

                return base;
            });
        };

        personInvolvedItems.forEach((category) => {
            if (values[category]?.length) {
                const mappedItems = mapCategoryItems(values[category], category);
                data_jsons.push(...mappedItems);
            }
        });

        formData.append('human_json', JSON.stringify(data_jsons));

        if (signatureBlob) {
            formData.append('images[]', signatureBlob, 'signature.png');
        }

        uploadedFiles.forEach(file => {
            console.log('file.signatureData', file)

            if (file.originalFile.type === 'application/pdf') {
                formData.append('images[]', file.originalFile);
            }

            if (file.signatureData) {
                const blob = dataURLtoBlob(file.signatureData);
                formData.append('images[]', blob, `signature_${file.originalFile.name}`);
            }
        });

        return formData;
    };

    const formik = useFormik({
        initialValues: initialValues,
        enableReinitialize: true,
        validationSchema: '',
        onSubmit: async (values) => {
            const postdata = transformFormValuesToPostData(values);
            setLoadings(true);
            try {
                const res = await postWhatOccurredStore(postdata);
                toast.success(res.data.message);
                postUpdateData();
            } catch (error) {
                toast.error(error?.response?.data?.message || 'Something went wrong');
            } finally {
                setLoadings(false);
            }
            console.log('postdata', postdata);
        },
    });
    const { values, handleChange, handleBlur, handleSubmit, setFieldValue, errors, touched } = formik;

    const dataURLtoBlob = (dataURL) => {
        const arr = dataURL.split(',');
        const mime = arr[0].match(/:(.*?);/)[1];
        const bstr = atob(arr[1]);
        let n = bstr.length;
        const u8arr = new Uint8Array(n);
        while (n--) {
            u8arr[n] = bstr.charCodeAt(n);
        }
        return new Blob([u8arr], { type: mime });
    };

    return (
        <>
            <div className="GroupList fieldset">
                <div className='toggle-button'>
                    <h2 className="listTitle">Car Park / Curbside Incident</h2>
                    <div className='btnColaps'><FaChevronUp /></div>
                </div>
                <div className="formsBox subFilds">
                    <form onSubmit={handleSubmit} autoComplete="off">
                        <div className="formsBox">
                            <Row>
                                <Col md={4}>
                                    <div className="form-group">
                                        <label>Person Involved</label>
                                        <div className="chkgroup">
                                            {personInvolvedChkItems.map((item) => {
                                                return (
                                                    <div className="chekbox" key={`PersonInvolved2_${item}`}>
                                                        <label>{item}
                                                            <input
                                                                value={item}
                                                                type="checkbox"
                                                                onChange={handlePersonInvolvedItemsChange}
                                                                checked={personInvolvedItems.includes(item)}
                                                            />
                                                            <span className="checkmark"></span>
                                                        </label>
                                                    </div>
                                                );
                                            })}
                                        </div>
                                    </div>
                                </Col>
                                <Col md={4}>
                                    <div className="form-group">
                                        <label>Injury Outcome</label>
                                        <div className="chkgroup Outcomechk">
                                            {injuryOutcomeChkItems.map((item) => {
                                                return (
                                                    <div className="chekbox" key={`Injury2_${item}`}>
                                                        <label>
                                                            <span className='colorsind'></span>
                                                            {item}
                                                            <input
                                                                value={item}
                                                                type="checkbox"
                                                                onChange={handleinjuryOutcomeItemsChange}
                                                                checked={injuryOutcomeItems.includes(item)}
                                                            />
                                                            <span className="checkmark"></span>
                                                        </label>
                                                    </div>
                                                );
                                            })}
                                        </div>
                                    </div>
                                </Col>
                                <Col md={4}>
                                    <div className="form-group">
                                        <label>Driver Name</label>
                                        <input
                                            type="text"
                                            className="form-control"
                                            name="driverName"
                                            value={values.driverName}
                                            onChange={handleChange}
                                            onBlur={handleBlur}
                                        />
                                    </div>
                                </Col>
                                <Col md={4}>
                                    <div className="form-group">
                                        <label>Driver License Details</label>
                                        <input
                                            type="text"
                                            className="form-control"
                                            name="driverLicenseDetails"
                                            value={values.driverLicenseDetails}
                                            onChange={handleChange}
                                            onBlur={handleBlur}
                                        />
                                    </div>
                                </Col>
                                <Col md={4}>
                                    <div className="form-group">
                                        <label>Vehicle Details</label>
                                        <input
                                            type="text"
                                            className="form-control"
                                            name="vehicleDetails"
                                            value={values.vehicleDetails}
                                            onChange={handleChange}
                                            onBlur={handleBlur}
                                        />
                                    </div>
                                </Col>
                                <Col md={4}>
                                    <div className="form-group">
                                        <label>Number of Vehicles Involved</label>
                                        <input
                                            type="text"
                                            className="form-control"
                                            name="numberOfVehiclesInvolved"
                                            value={values.numberOfVehiclesInvolved}
                                            onChange={handleChange}
                                            onBlur={handleBlur}
                                        />
                                    </div>
                                </Col>
                                <Col md={4}>
                                    <div className="form-group">
                                        <label>Speed of Vehicle</label>
                                        <input
                                            type="text"
                                            className="form-control"
                                            name="speedOfVehicle"
                                            value={values.speedOfVehicle}
                                            onChange={handleChange}
                                            onBlur={handleBlur}
                                        />
                                    </div>
                                </Col>
                                <Col md={4}>
                                    <div className="form-group">
                                        <label>Insurance Details</label>
                                        <input
                                            type="text"
                                            className="form-control"
                                            name="insuranceDetails"
                                            value={values.insuranceDetails}
                                            onChange={handleChange}
                                            onBlur={handleBlur}
                                        />
                                    </div>
                                </Col>
                            </Row>
                        </div>

                        <div className="fieldset">
                            <h1>Vehicle incursions & accidents</h1>
                            <div className="formsBox">
                                <div className='canvasbox'>
                                    <canvas
                                        ref={canvasRef}
                                        style={{
                                            width: '270px',
                                            height: '431px',
                                            touchAction: 'none'
                                        }}
                                    ></canvas>
                                    <button className='btn btn-red' onClick={clearSignature} type="button">Clear</button>
                                </div>
                            </div>
                        </div>

                        <div className="formContainer">
                            <div id="passenger" className="multiGroup" style={{ display: personInvolvedItems.includes('passenger') ? 'block' : 'none' }}>
                                {values.passenger.map((pas, index) => (
                                    <div key={`passengers_${index}`} className="fieldset mainFS">
                                        <div className="statetitle_btn">
                                            <h1 className="titles">Passenger <span>{index + 1}</span></h1>
                                            <div className="addreovebtns">
                                                <button type="button" className="btn add-btn" onClick={addPassenger}>+</button>
                                                {values.passenger.length > 1 && (
                                                    <button type="button" className="btn remove-btn" onClick={() => removePassenger(index)}>-</button>
                                                )}
                                            </div>
                                        </div>

                                        <div className="formsBox">
                                            <Row>
                                                <Col md={4}>
                                                    <div className="form-group">
                                                        <label>Passenger name</label>
                                                        <input
                                                            type="text"
                                                            name={`passenger[${index}].passengerName`}
                                                            className="form-control"
                                                            value={pas.passengerName}
                                                            onChange={(e) => setFieldValue(`passenger[${index}].passengerName`, e.target.value)}
                                                        />
                                                    </div>
                                                </Col>
                                                <Col md={4}>
                                                    <div className="form-group">
                                                        <label>Passenger Passport No.</label>
                                                        <input
                                                            type="text"
                                                            name={`passenger[${index}].passportNumber`}
                                                            className="form-control"
                                                            value={pas.passportNumber}
                                                            onChange={(e) => setFieldValue(`passenger[${index}].passportNumber`, e.target.value)}
                                                        />
                                                    </div>
                                                </Col>
                                                <Col md={4}>
                                                    <div className="form-group">
                                                        <label>Date</label>
                                                        <DateFild
                                                            value={pas.date}
                                                            onChange={(date) => setFieldValue(`passenger[${index}].date`, date)}
                                                        />
                                                    </div>
                                                </Col>
                                                <Col md={4}>
                                                    <div className="form-group">
                                                        <label>Date of Pain Onset</label>
                                                        <DateFild
                                                            value={pas.dateofPainOnset}
                                                            onChange={(date) => setFieldValue(`passenger[${index}].dateofPainOnset`, date)}
                                                        />
                                                    </div>
                                                </Col>
                                                <Col md={4}>
                                                    <div className="form-group">
                                                        <label>Frequency and duration of pain</label>
                                                        <input
                                                            type="text"
                                                            name={`passenger[${index}].frequencyAndDurationofPain`}
                                                            className="form-control"
                                                            value={pas.frequencyAndDurationofPain}
                                                            onChange={(e) =>
                                                                setFieldValue(
                                                                    `passenger[${index}].frequencyAndDurationofPain`,
                                                                    e.target.value
                                                                )
                                                            }
                                                        />
                                                    </div>
                                                </Col>
                                                <Col md={4}>
                                                    <div className="form-group">
                                                        <label>Gender</label>
                                                        <div className="chkgroup">
                                                            {[
                                                                "Male", "Female"
                                                            ].map((part) => (
                                                                <div className="chekbox" key={part}>
                                                                    <label>{part}
                                                                        <input
                                                                            type="checkbox"
                                                                            value={part}
                                                                            checked={pas.gender?.includes(part) || false}
                                                                            onChange={(e) => {
                                                                                const selected = pas.gender || [];
                                                                                const updated = e.target.checked
                                                                                    ? [...selected, part]
                                                                                    : selected.filter((p) => p !== part);
                                                                                setFieldValue(`passenger[${index}].gender`, updated);
                                                                            }}
                                                                        />
                                                                        <span className="checkmark"></span>
                                                                    </label>
                                                                </div>
                                                            ))}
                                                        </div>
                                                    </div>
                                                </Col>
                                            </Row>

                                            <div style={{ display: pas.gender?.includes('Male') || pas.gender?.includes('Female') ? 'block' : 'none' }}>
                                                <div className="infoboxss">
                                                    <p><b>Rt</b> = Right</p>
                                                    <p><b>Lt</b> = Left</p>
                                                </div>
                                            </div>

                                            <div style={{ display: pas.gender?.includes('Male') ? 'block' : 'none' }}>
                                                <div className="painchart_Box">
                                                    <div className="chartimg">
                                                        <div className="Chartbox">
                                                            <img src={bodyL} alt="Body Left" />
                                                            <div className="leftChekList">
                                                                {[
                                                                    "Face", "Lt jaw", "Lt chest/breast", "Lt upper arm", "Lt elbow",
                                                                    "Lt lower arm", "Lt groin", "Lt wisthand/Hand", "Lt upper leg",
                                                                    "Lt knee", "Lt lower leg", "Lt ankle/foot"
                                                                ].map((part) => (
                                                                    <div className="chekbox" key={part}>
                                                                        <label>{part}
                                                                            <input
                                                                                type="checkbox"
                                                                                value={part}
                                                                                checked={pas.painLocations?.includes(part) || false}
                                                                                onChange={(e) => {
                                                                                    const selected = pas.painLocations || [];
                                                                                    const updated = e.target.checked
                                                                                        ? [...selected, part]
                                                                                        : selected.filter((p) => p !== part);
                                                                                    setFieldValue(`passenger[${index}].painLocations`, updated);
                                                                                }}
                                                                            />
                                                                            <span className="checkmark"></span>
                                                                        </label>
                                                                    </div>
                                                                ))}
                                                            </div>
                                                            <div className="rightChekList">
                                                                {[
                                                                    "Rt chest/breast", "Rt upper arm", "Rt elbow", "Rt lower arm",
                                                                    "Pelvis", "Rt groin", "Rt wrist/hand", "Rt upper leg",
                                                                    "Rt knee", "Rt lower leg", "Rt ankle/foot"
                                                                ].map((part) => (
                                                                    <div className="chekbox" key={part}>
                                                                        <label>{part}
                                                                            <input
                                                                                type="checkbox"
                                                                                value={part}
                                                                                checked={pas.painLocations?.includes(part) || false}
                                                                                onChange={(e) => {
                                                                                    const selected = pas.painLocations || [];
                                                                                    const updated = e.target.checked
                                                                                        ? [...selected, part]
                                                                                        : selected.filter((p) => p !== part);
                                                                                    setFieldValue(`passenger[${index}].painLocations`, updated);
                                                                                }}
                                                                            />
                                                                            <span className="checkmark"></span>
                                                                        </label>
                                                                    </div>
                                                                ))}
                                                            </div>
                                                        </div>

                                                        <div className="Chartbox rightimgs">
                                                            <img src={bodyR} alt="Body Right" />
                                                            <div className="leftChekList">
                                                                {[
                                                                    "Neck", "Rt shoulder", "Upper back", "Lower back",
                                                                    "Rt hip", "Rt buttocks"
                                                                ].map((part) => (
                                                                    <div className="chekbox" key={part}>
                                                                        <label>{part}
                                                                            <input
                                                                                type="checkbox"
                                                                                value={part}
                                                                                checked={pas.painLocations?.includes(part) || false}
                                                                                onChange={(e) => {
                                                                                    const selected = pas.painLocations || [];
                                                                                    const updated = e.target.checked
                                                                                        ? [...selected, part]
                                                                                        : selected.filter((p) => p !== part);
                                                                                    setFieldValue(`passenger[${index}].painLocations`, updated);
                                                                                }}
                                                                            />
                                                                            <span className="checkmark"></span>
                                                                        </label>
                                                                    </div>
                                                                ))}
                                                            </div>
                                                            <div className="rightChekList">
                                                                {[
                                                                    "Head", "Lt shoulder", "Li hip", "Lt buttocks"
                                                                ].map((part) => (
                                                                    <div className="chekbox" key={part}>
                                                                        <label>{part}
                                                                            <input
                                                                                type="checkbox"
                                                                                value={part}
                                                                                checked={pas.painLocations?.includes(part) || false}
                                                                                onChange={(e) => {
                                                                                    const selected = pas.painLocations || [];
                                                                                    const updated = e.target.checked
                                                                                        ? [...selected, part]
                                                                                        : selected.filter((p) => p !== part);
                                                                                    setFieldValue(`passenger[${index}].painLocations`, updated);
                                                                                }}
                                                                            />
                                                                            <span className="checkmark"></span>
                                                                        </label>
                                                                    </div>
                                                                ))}
                                                            </div>
                                                        </div>
                                                    </div>
                                                    {pas.painLocations?.length > 0 ? (
                                                        <div className="fieldset">
                                                            <h1>Male Pain locations</h1>
                                                            <div className="selectedList">
                                                                {pas.painLocations.map((loc, i) => (
                                                                    <span key={i}>{loc}</span>
                                                                ))}
                                                            </div>
                                                        </div>
                                                    ) : null}
                                                </div>

                                                <div className="form-group">
                                                    <label>Male Pain descriptions</label>
                                                    <div className="chkgroup">
                                                        {["Ache", "Burning", "Numbness", "Pins and needles", "Stabbing", "Throbbing", "Other:"].map((desc) => (
                                                            <div className="chekbox" key={desc}>
                                                                <label>{desc}
                                                                    <input
                                                                        type="checkbox"
                                                                        value={desc}
                                                                        checked={pas.painDescriptions?.includes(desc) || false}
                                                                        onChange={(e) => {
                                                                            const selected = pas.painDescriptions || [];
                                                                            const updated = e.target.checked
                                                                                ? [...selected, desc]
                                                                                : selected.filter(d => d !== desc);
                                                                            setFieldValue(`passenger[${index}].painDescriptions`, updated);
                                                                        }}
                                                                    />
                                                                    <span className="checkmark"></span>
                                                                </label>
                                                            </div>
                                                        ))}
                                                    </div>
                                                </div>

                                                <div className="form-group">
                                                    <label>Male Pain intensity</label>
                                                    <div className="chkgroup">
                                                        {["No pain", "1-3: Mild", "4-6: Moderate", "7-9: Severe", "10: Worst possible pain"].map((level) => (
                                                            <div className="chekbox" key={level}>
                                                                <label>{level}
                                                                    <input
                                                                        type="checkbox"
                                                                        value={level}
                                                                        checked={pas.painIntensity?.includes(level) || false}
                                                                        onChange={(e) => {
                                                                            const selected = pas.painIntensity || [];
                                                                            const updated = e.target.checked
                                                                                ? [...selected, level]
                                                                                : selected.filter(l => l !== level);
                                                                            setFieldValue(`passenger[${index}].painIntensity`, updated);
                                                                        }}
                                                                    />
                                                                    <span className="checkmark"></span>
                                                                </label>
                                                            </div>
                                                        ))}
                                                    </div>
                                                </div>

                                                <div className="form-group">
                                                    <label>Male Other symptoms (if any)</label>
                                                    <textarea
                                                        className="form-control"
                                                        name={`passenger[${index}].otherSymptoms`}
                                                        value={pas.otherSymptoms || ''}
                                                        onChange={(e) => setFieldValue(`passenger[${index}].otherSymptoms`, e.target.value)}
                                                    />
                                                </div>
                                            </div>

                                            <div style={{ display: pas.gender?.includes('Female') ? 'block' : 'none' }}>
                                                <div className="painchart_Box">
                                                    <div className="chartimg Fe">
                                                        <div className="Chartbox">
                                                            <img src={womenbodyL} alt="Body Left" />
                                                            <div className="leftChekList">
                                                                {[
                                                                    "Face", "Lt jaw", "Lt chest/breast", "Lt upper arm", "Lt elbow",
                                                                    "Lt lower arm", "Lt groin", "Lt wisthand/Hand", "Lt upper leg",
                                                                    "Lt knee", "Lt lower leg", "Lt ankle/foot"
                                                                ].map((part) => (
                                                                    <div className="chekbox" key={part}>
                                                                        <label>{part}
                                                                            <input
                                                                                type="checkbox"
                                                                                value={part}
                                                                                checked={pas.FpainLocations?.includes(part) || false}
                                                                                onChange={(e) => {
                                                                                    const selected = pas.FpainLocations || [];
                                                                                    const updated = e.target.checked
                                                                                        ? [...selected, part]
                                                                                        : selected.filter((p) => p !== part);
                                                                                    setFieldValue(`passenger[${index}].FpainLocations`, updated);
                                                                                }}
                                                                            />
                                                                            <span className="checkmark"></span>
                                                                        </label>
                                                                    </div>
                                                                ))}
                                                            </div>
                                                            <div className="rightChekList">
                                                                {[
                                                                    "Rt chest/breast", "Rt upper arm", "Rt elbow", "Rt lower arm",
                                                                    "Pelvis", "Rt groin", "Rt wrist/hand", "Rt upper leg",
                                                                    "Rt knee", "Rt lower leg", "Rt ankle/foot"
                                                                ].map((part) => (
                                                                    <div className="chekbox" key={part}>
                                                                        <label>{part}
                                                                            <input
                                                                                type="checkbox"
                                                                                value={part}
                                                                                checked={pas.FpainLocations?.includes(part) || false}
                                                                                onChange={(e) => {
                                                                                    const selected = pas.FpainLocations || [];
                                                                                    const updated = e.target.checked
                                                                                        ? [...selected, part]
                                                                                        : selected.filter((p) => p !== part);
                                                                                    setFieldValue(`passenger[${index}].FpainLocations`, updated);
                                                                                }}
                                                                            />
                                                                            <span className="checkmark"></span>
                                                                        </label>
                                                                    </div>
                                                                ))}
                                                            </div>
                                                        </div>

                                                        <div className="Chartbox rightimgs">
                                                            <img src={womenbodyR} alt="Body Right" />
                                                            <div className="leftChekList">
                                                                {[
                                                                    "Neck", "Rt shoulder", "Upper back", "Lower back",
                                                                    "Rt hip", "Rt buttocks"
                                                                ].map((part) => (
                                                                    <div className="chekbox" key={part}>
                                                                        <label>{part}
                                                                            <input
                                                                                type="checkbox"
                                                                                value={part}
                                                                                checked={pas.FpainLocations?.includes(part) || false}
                                                                                onChange={(e) => {
                                                                                    const selected = pas.FpainLocations || [];
                                                                                    const updated = e.target.checked
                                                                                        ? [...selected, part]
                                                                                        : selected.filter((p) => p !== part);
                                                                                    setFieldValue(`passenger[${index}].FpainLocations`, updated);
                                                                                }}
                                                                            />
                                                                            <span className="checkmark"></span>
                                                                        </label>
                                                                    </div>
                                                                ))}
                                                            </div>
                                                            <div className="rightChekList">
                                                                {[
                                                                    "Head", "Lt shoulder", "Li hip", "Lt buttocks"
                                                                ].map((part) => (
                                                                    <div className="chekbox" key={part}>
                                                                        <label>{part}
                                                                            <input
                                                                                type="checkbox"
                                                                                value={part}
                                                                                checked={pas.FpainLocations?.includes(part) || false}
                                                                                onChange={(e) => {
                                                                                    const selected = pas.FpainLocations || [];
                                                                                    const updated = e.target.checked
                                                                                        ? [...selected, part]
                                                                                        : selected.filter((p) => p !== part);
                                                                                    setFieldValue(`passenger[${index}].FpainLocations`, updated);
                                                                                }}
                                                                            />
                                                                            <span className="checkmark"></span>
                                                                        </label>
                                                                    </div>
                                                                ))}
                                                            </div>
                                                        </div>
                                                    </div>
                                                    {pas.FpainLocations?.length > 0 ? (
                                                        <div className="fieldset">
                                                            <h1>Female Pain locations</h1>
                                                            <div className="selectedList">
                                                                {pas.FpainLocations.map((loc, i) => (
                                                                    <span key={i}>{loc}</span>
                                                                ))}
                                                            </div>
                                                        </div>
                                                    ) : null}
                                                </div>

                                                <div className="form-group">
                                                    <label>Female Pain descriptions</label>
                                                    <div className="chkgroup">
                                                        {["Ache", "Burning", "Numbness", "Pins and needles", "Stabbing", "Throbbing", "Other:"].map((desc) => (
                                                            <div className="chekbox" key={desc}>
                                                                <label>{desc}
                                                                    <input
                                                                        type="checkbox"
                                                                        value={desc}
                                                                        checked={pas.FpainDescriptions?.includes(desc) || false}
                                                                        onChange={(e) => {
                                                                            const selected = pas.FpainDescriptions || [];
                                                                            const updated = e.target.checked
                                                                                ? [...selected, desc]
                                                                                : selected.filter(d => d !== desc);
                                                                            setFieldValue(`passenger[${index}].FpainDescriptions`, updated);
                                                                        }}
                                                                    />
                                                                    <span className="checkmark"></span>
                                                                </label>
                                                            </div>
                                                        ))}
                                                    </div>
                                                </div>

                                                <div className="form-group">
                                                    <label>Female Pain intensity</label>
                                                    <div className="chkgroup">
                                                        {["No pain", "1-3: Mild", "4-6: Moderate", "7-9: Severe", "10: Worst possible pain"].map((level) => (
                                                            <div className="chekbox" key={level}>
                                                                <label>{level}
                                                                    <input
                                                                        type="checkbox"
                                                                        value={level}
                                                                        checked={pas.FpainIntensity?.includes(level) || false}
                                                                        onChange={(e) => {
                                                                            const selected = pas.FpainIntensity || [];
                                                                            const updated = e.target.checked
                                                                                ? [...selected, level]
                                                                                : selected.filter(l => l !== level);
                                                                            setFieldValue(`passenger[${index}].FpainIntensity`, updated);
                                                                        }}
                                                                    />
                                                                    <span className="checkmark"></span>
                                                                </label>
                                                            </div>
                                                        ))}
                                                    </div>
                                                </div>

                                                <div className="form-group">
                                                    <label>Female Other symptoms (if any)</label>
                                                    <textarea
                                                        className="form-control"
                                                        name={`passenger[${index}].FotherSymptoms`}
                                                        value={pas.FotherSymptoms || ''}
                                                        onChange={(e) => setFieldValue(`passenger[${index}].FotherSymptoms`, e.target.value)}
                                                    />
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                ))}
                            </div>

                            <div id="staff" className="multiGroup" style={{ display: personInvolvedItems.includes('staff') ? 'block' : 'none' }}>
                                {values.staff.map((stf, index) => (
                                    <div key={`staffs_${index}`} className="fieldset mainFS">
                                        <div className="statetitle_btn">
                                            <h1 className="titles">Staff <span>{index + 1}</span></h1>
                                            <div className="addreovebtns">
                                                <button type="button" className="btn add-btn" onClick={addStaff}>+</button>
                                                {values.staff.length > 1 && (
                                                    <button type="button" className="btn remove-btn" onClick={() => removeStaff(index)}>-</button>
                                                )}
                                            </div>
                                        </div>
                                        <div className="formsBox">
                                            <Row>
                                                <Col md={4}>
                                                    <div className="form-group">
                                                        <label>Staff Name</label>
                                                        <input
                                                            type="text"
                                                            name={`staff[${index}].staffName`}
                                                            className="form-control"
                                                            value={stf.staffName}
                                                            onChange={(e) => setFieldValue(`staff[${index}].staffName`, e.target.value)}
                                                        />
                                                    </div>
                                                </Col>
                                                <Col md={4}>
                                                    <div className="form-group">
                                                        <label>Staff id</label>
                                                        <input
                                                            type="text"
                                                            name={`staff[${index}].staffId`}
                                                            className="form-control"
                                                            value={stf.staffId}
                                                            onChange={(e) => setFieldValue(`staff[${index}].staffId`, e.target.value)}
                                                        />
                                                    </div>
                                                </Col>
                                                <Col md={4}>
                                                    <div className="form-group">
                                                        <label>Date</label>
                                                        <DateFild
                                                            value={stf.date}
                                                            onChange={(date) => setFieldValue(`staff[${index}].date`, date)}
                                                        />
                                                    </div>
                                                </Col>
                                                <Col md={4}>
                                                    <div className="form-group">
                                                        <label>Date of Pain Onset</label>
                                                        <DateFild
                                                            value={stf.dateofPainOnset}
                                                            onChange={(date) => setFieldValue(`staff[${index}].dateofPainOnset`, date)}
                                                        />
                                                    </div>
                                                </Col>
                                                <Col md={4}>
                                                    <div className="form-group">
                                                        <label>Frequency and duration of pain </label>
                                                        <input
                                                            type="text"
                                                            name={`staff[${index}].frequencyAndDurationofPain`}
                                                            className="form-control"
                                                            value={stf.frequencyAndDurationofPain}
                                                            onChange={(e) => setFieldValue(`staff[${index}].frequencyAndDurationofPain`, e.target.value)}
                                                        />
                                                    </div>
                                                </Col>
                                                <Col md={4}>
                                                    <div className="form-group">
                                                        <label>Gender</label>
                                                        <div className="chkgroup">
                                                            {[
                                                                "Male", "Female"
                                                            ].map((part) => (
                                                                <div className="chekbox" key={part}>
                                                                    <label>{part}
                                                                        <input
                                                                            type="checkbox"
                                                                            value={part}
                                                                            checked={stf.gender?.includes(part) || false}
                                                                            onChange={(e) => {
                                                                                const selected = stf.gender || [];
                                                                                const updated = e.target.checked
                                                                                    ? [...selected, part]
                                                                                    : selected.filter((p) => p !== part);
                                                                                setFieldValue(`staff[${index}].gender`, updated);
                                                                            }}
                                                                        />
                                                                        <span className="checkmark"></span>
                                                                    </label>
                                                                </div>
                                                            ))}
                                                        </div>
                                                    </div>
                                                </Col>
                                            </Row>

                                            <div style={{ display: stf.gender?.includes('Male') || stf.gender?.includes('Female') ? 'block' : 'none' }}>
                                                <div className="infoboxss">
                                                    <p><b>Rt</b> = Right</p>
                                                    <p><b>Lt</b> = Left</p>
                                                </div>
                                            </div>

                                            <div style={{ display: stf.gender?.includes('Male') ? 'block' : 'none' }}>
                                                <div className="painchart_Box">
                                                    <div className="chartimg">
                                                        <div className="Chartbox">
                                                            <img src={bodyL} alt="Body Left" />
                                                            <div className="leftChekList">
                                                                {[
                                                                    "Face", "Lt jaw", "Lt chest/breast", "Lt upper arm", "Lt elbow",
                                                                    "Lt lower arm", "Lt groin", "Lt wisthand/Hand", "Lt upper leg",
                                                                    "Lt knee", "Lt lower leg", "Lt ankle/foot"
                                                                ].map((part) => (
                                                                    <div className="chekbox" key={part}>
                                                                        <label>{part}
                                                                            <input
                                                                                type="checkbox"
                                                                                value={part}
                                                                                checked={stf.painLocations?.includes(part) || false}
                                                                                onChange={(e) => {
                                                                                    const selected = stf.painLocations || [];
                                                                                    const updated = e.target.checked
                                                                                        ? [...selected, part]
                                                                                        : selected.filter((p) => p !== part);
                                                                                    setFieldValue(`staff[${index}].painLocations`, updated);
                                                                                }}
                                                                            />
                                                                            <span className="checkmark"></span>
                                                                        </label>
                                                                    </div>
                                                                ))}
                                                            </div>
                                                            <div className="rightChekList">
                                                                {[
                                                                    "Rt chest/breast", "Rt upper arm", "Rt elbow", "Rt lower arm",
                                                                    "Pelvis", "Rt groin", "Rt wrist/hand", "Rt upper leg",
                                                                    "Rt knee", "Rt lower leg", "Rt ankle/foot"
                                                                ].map((part) => (
                                                                    <div className="chekbox" key={part}>
                                                                        <label>{part}
                                                                            <input
                                                                                type="checkbox"
                                                                                value={part}
                                                                                checked={stf.painLocations?.includes(part) || false}
                                                                                onChange={(e) => {
                                                                                    const selected = stf.painLocations || [];
                                                                                    const updated = e.target.checked
                                                                                        ? [...selected, part]
                                                                                        : selected.filter((p) => p !== part);
                                                                                    setFieldValue(`staff[${index}].painLocations`, updated);
                                                                                }}
                                                                            />
                                                                            <span className="checkmark"></span>
                                                                        </label>
                                                                    </div>
                                                                ))}
                                                            </div>
                                                        </div>

                                                        <div className="Chartbox rightimgs">
                                                            <img src={bodyR} alt="Body Right" />
                                                            <div className="leftChekList">
                                                                {[
                                                                    "Neck", "Rt shoulder", "Upper back", "Lower back",
                                                                    "Rt hip", "Rt buttocks"
                                                                ].map((part) => (
                                                                    <div className="chekbox" key={part}>
                                                                        <label>{part}
                                                                            <input
                                                                                type="checkbox"
                                                                                value={part}
                                                                                checked={stf.painLocations?.includes(part) || false}
                                                                                onChange={(e) => {
                                                                                    const selected = stf.painLocations || [];
                                                                                    const updated = e.target.checked
                                                                                        ? [...selected, part]
                                                                                        : selected.filter((p) => p !== part);
                                                                                    setFieldValue(`staff[${index}].painLocations`, updated);
                                                                                }}
                                                                            />
                                                                            <span className="checkmark"></span>
                                                                        </label>
                                                                    </div>
                                                                ))}
                                                            </div>
                                                            <div className="rightChekList">
                                                                {[
                                                                    "Head", "Lt shoulder", "Li hip", "Lt buttocks"
                                                                ].map((part) => (
                                                                    <div className="chekbox" key={part}>
                                                                        <label>{part}
                                                                            <input
                                                                                type="checkbox"
                                                                                value={part}
                                                                                checked={stf.painLocations?.includes(part) || false}
                                                                                onChange={(e) => {
                                                                                    const selected = stf.painLocations || [];
                                                                                    const updated = e.target.checked
                                                                                        ? [...selected, part]
                                                                                        : selected.filter((p) => p !== part);
                                                                                    setFieldValue(`staff[${index}].painLocations`, updated);
                                                                                }}
                                                                            />
                                                                            <span className="checkmark"></span>
                                                                        </label>
                                                                    </div>
                                                                ))}
                                                            </div>
                                                        </div>
                                                    </div>
                                                    {stf.painLocations?.length > 0 ? (
                                                        <div className="fieldset">
                                                            <h1>Male Pain locations</h1>
                                                            <div className="selectedList">
                                                                {stf.painLocations.map((loc, i) => (
                                                                    <span key={i}>{loc}</span>
                                                                ))}
                                                            </div>
                                                        </div>
                                                    ) : null}
                                                </div>

                                                <div className="form-group">
                                                    <label>Male Pain descriptions</label>
                                                    <div className="chkgroup">
                                                        {["Ache", "Burning", "Numbness", "Pins and needles", "Stabbing", "Throbbing", "Other:"].map((desc) => (
                                                            <div className="chekbox" key={desc}>
                                                                <label>{desc}
                                                                    <input
                                                                        type="checkbox"
                                                                        value={desc}
                                                                        checked={stf.painDescriptions?.includes(desc) || false}
                                                                        onChange={(e) => {
                                                                            const selected = stf.painDescriptions || [];
                                                                            const updated = e.target.checked
                                                                                ? [...selected, desc]
                                                                                : selected.filter(d => d !== desc);
                                                                            setFieldValue(`staff[${index}].painDescriptions`, updated);
                                                                        }}
                                                                    />
                                                                    <span className="checkmark"></span>
                                                                </label>
                                                            </div>
                                                        ))}
                                                    </div>
                                                </div>

                                                <div className="form-group">
                                                    <label>Male Pain intensity</label>
                                                    <div className="chkgroup">
                                                        {["No pain", "1-3: Mild", "4-6: Moderate", "7-9: Severe", "10: Worst possible pain"].map((level) => (
                                                            <div className="chekbox" key={level}>
                                                                <label>{level}
                                                                    <input
                                                                        type="checkbox"
                                                                        value={level}
                                                                        checked={stf.painIntensity?.includes(level) || false}
                                                                        onChange={(e) => {
                                                                            const selected = stf.painIntensity || [];
                                                                            const updated = e.target.checked
                                                                                ? [...selected, level]
                                                                                : selected.filter(l => l !== level);
                                                                            setFieldValue(`staff[${index}].painIntensity`, updated);
                                                                        }}
                                                                    />
                                                                    <span className="checkmark"></span>
                                                                </label>
                                                            </div>
                                                        ))}
                                                    </div>
                                                </div>

                                                <div className="form-group">
                                                    <label>Male Other symptoms (if any)</label>
                                                    <textarea
                                                        className="form-control"
                                                        name={`staff[${index}].otherSymptoms`}
                                                        value={stf.otherSymptoms || ''}
                                                        onChange={(e) => setFieldValue(`staff[${index}].otherSymptoms`, e.target.value)}
                                                    />
                                                </div>
                                            </div>

                                            <div style={{ display: stf.gender?.includes('Female') ? 'block' : 'none' }}>
                                                <div className="painchart_Box">
                                                    <div className="chartimg Fe">
                                                        <div className="Chartbox">
                                                            <img src={womenbodyL} alt="Body Left" />
                                                            <div className="leftChekList">
                                                                {[
                                                                    "Face", "Lt jaw", "Lt chest/breast", "Lt upper arm", "Lt elbow",
                                                                    "Lt lower arm", "Lt groin", "Lt wisthand/Hand", "Lt upper leg",
                                                                    "Lt knee", "Lt lower leg", "Lt ankle/foot"
                                                                ].map((part) => (
                                                                    <div className="chekbox" key={part}>
                                                                        <label>{part}
                                                                            <input
                                                                                type="checkbox"
                                                                                value={part}
                                                                                checked={stf.FpainLocations?.includes(part) || false}
                                                                                onChange={(e) => {
                                                                                    const selected = stf.FpainLocations || [];
                                                                                    const updated = e.target.checked
                                                                                        ? [...selected, part]
                                                                                        : selected.filter((p) => p !== part);
                                                                                    setFieldValue(`staff[${index}].FpainLocations`, updated);
                                                                                }}
                                                                            />
                                                                            <span className="checkmark"></span>
                                                                        </label>
                                                                    </div>
                                                                ))}
                                                            </div>
                                                            <div className="rightChekList">
                                                                {[
                                                                    "Rt chest/breast", "Rt upper arm", "Rt elbow", "Rt lower arm",
                                                                    "Pelvis", "Rt groin", "Rt wrist/hand", "Rt upper leg",
                                                                    "Rt knee", "Rt lower leg", "Rt ankle/foot"
                                                                ].map((part) => (
                                                                    <div className="chekbox" key={part}>
                                                                        <label>{part}
                                                                            <input
                                                                                type="checkbox"
                                                                                value={part}
                                                                                checked={stf.FpainLocations?.includes(part) || false}
                                                                                onChange={(e) => {
                                                                                    const selected = stf.FpainLocations || [];
                                                                                    const updated = e.target.checked
                                                                                        ? [...selected, part]
                                                                                        : selected.filter((p) => p !== part);
                                                                                    setFieldValue(`staff[${index}].FpainLocations`, updated);
                                                                                }}
                                                                            />
                                                                            <span className="checkmark"></span>
                                                                        </label>
                                                                    </div>
                                                                ))}
                                                            </div>
                                                        </div>

                                                        <div className="Chartbox rightimgs">
                                                            <img src={womenbodyR} alt="Body Right" />
                                                            <div className="leftChekList">
                                                                {[
                                                                    "Neck", "Rt shoulder", "Upper back", "Lower back",
                                                                    "Rt hip", "Rt buttocks"
                                                                ].map((part) => (
                                                                    <div className="chekbox" key={part}>
                                                                        <label>{part}
                                                                            <input
                                                                                type="checkbox"
                                                                                value={part}
                                                                                checked={stf.FpainLocations?.includes(part) || false}
                                                                                onChange={(e) => {
                                                                                    const selected = stf.FpainLocations || [];
                                                                                    const updated = e.target.checked
                                                                                        ? [...selected, part]
                                                                                        : selected.filter((p) => p !== part);
                                                                                    setFieldValue(`staff[${index}].FpainLocations`, updated);
                                                                                }}
                                                                            />
                                                                            <span className="checkmark"></span>
                                                                        </label>
                                                                    </div>
                                                                ))}
                                                            </div>
                                                            <div className="rightChekList">
                                                                {[
                                                                    "Head", "Lt shoulder", "Li hip", "Lt buttocks"
                                                                ].map((part) => (
                                                                    <div className="chekbox" key={part}>
                                                                        <label>{part}
                                                                            <input
                                                                                type="checkbox"
                                                                                value={part}
                                                                                checked={stf.FpainLocations?.includes(part) || false}
                                                                                onChange={(e) => {
                                                                                    const selected = stf.FpainLocations || [];
                                                                                    const updated = e.target.checked
                                                                                        ? [...selected, part]
                                                                                        : selected.filter((p) => p !== part);
                                                                                    setFieldValue(`staff[${index}].FpainLocations`, updated);
                                                                                }}
                                                                            />
                                                                            <span className="checkmark"></span>
                                                                        </label>
                                                                    </div>
                                                                ))}
                                                            </div>
                                                        </div>
                                                    </div>
                                                    {stf.FpainLocations?.length > 0 ? (
                                                        <div className="fieldset">
                                                            <h1>Female Pain locations</h1>
                                                            <div className="selectedList">
                                                                {stf.FpainLocations.map((loc, i) => (
                                                                    <span key={i}>{loc}</span>
                                                                ))}
                                                            </div>
                                                        </div>
                                                    ) : null}
                                                </div>

                                                <div className="form-group">
                                                    <label>Female Pain descriptions</label>
                                                    <div className="chkgroup">
                                                        {["Ache", "Burning", "Numbness", "Pins and needles", "Stabbing", "Throbbing", "Other:"].map((desc) => (
                                                            <div className="chekbox" key={desc}>
                                                                <label>{desc}
                                                                    <input
                                                                        type="checkbox"
                                                                        value={desc}
                                                                        checked={stf.FpainDescriptions?.includes(desc) || false}
                                                                        onChange={(e) => {
                                                                            const selected = stf.FpainDescriptions || [];
                                                                            const updated = e.target.checked
                                                                                ? [...selected, desc]
                                                                                : selected.filter(d => d !== desc);
                                                                            setFieldValue(`staff[${index}].FpainDescriptions`, updated);
                                                                        }}
                                                                    />
                                                                    <span className="checkmark"></span>
                                                                </label>
                                                            </div>
                                                        ))}
                                                    </div>
                                                </div>

                                                <div className="form-group">
                                                    <label>Female Pain intensity</label>
                                                    <div className="chkgroup">
                                                        {["No pain", "1-3: Mild", "4-6: Moderate", "7-9: Severe", "10: Worst possible pain"].map((level) => (
                                                            <div className="chekbox" key={level}>
                                                                <label>{level}
                                                                    <input
                                                                        type="checkbox"
                                                                        value={level}
                                                                        checked={stf.FpainIntensity?.includes(level) || false}
                                                                        onChange={(e) => {
                                                                            const selected = stf.FpainIntensity || [];
                                                                            const updated = e.target.checked
                                                                                ? [...selected, level]
                                                                                : selected.filter(l => l !== level);
                                                                            setFieldValue(`staff[${index}].FpainIntensity`, updated);
                                                                        }}
                                                                    />
                                                                    <span className="checkmark"></span>
                                                                </label>
                                                            </div>
                                                        ))}
                                                    </div>
                                                </div>

                                                <div className="form-group">
                                                    <label>Female Other symptoms (if any)</label>
                                                    <textarea
                                                        className="form-control"
                                                        name={`staff[${index}].FotherSymptoms`}
                                                        value={stf.FotherSymptoms || ''}
                                                        onChange={(e) => setFieldValue(`staff[${index}].FotherSymptoms`, e.target.value)}
                                                    />
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                ))}
                            </div>

                            <div id="contractor" className="multiGroup" style={{ display: personInvolvedItems.includes('contractor') ? 'block' : 'none' }}>
                                {values.contractor.map((con, index) => (
                                    <div key={`contractors_${index}`} className="fieldset mainFS">
                                        <div className="statetitle_btn">
                                            <h1 className="titles">Contractor <span>{index + 1}</span></h1>
                                            <div className="addreovebtns">
                                                <button type="button" className="btn add-btn" onClick={addContractor}>+</button>
                                                {values.contractor.length > 1 && (
                                                    <button type="button" className="btn remove-btn" onClick={() => removeContractor(index)}>-</button>
                                                )}
                                            </div>
                                        </div>
                                        <div className="formsBox">
                                            <Row>
                                                <Col md={4}>
                                                    <div className="form-group">
                                                        <label>Contractor name</label>
                                                        <input
                                                            type="text"
                                                            name={`contractor[${index}].contractorName`}
                                                            className="form-control"
                                                            value={con.contractorName}
                                                            onChange={(e) => setFieldValue(`contractor[${index}].contractorName`, e.target.value)}
                                                        />
                                                    </div>
                                                </Col>
                                                <Col md={4}>
                                                    <div className="form-group">
                                                        <label>Contractor id</label>
                                                        <input
                                                            type="text"
                                                            name={`contractor[${index}].contractorId`}
                                                            className="form-control"
                                                            value={con.contractorId}
                                                            onChange={(e) => setFieldValue(`contractor[${index}].contractorId`, e.target.value)}
                                                        />
                                                    </div>
                                                </Col>
                                                <Col md={4}>
                                                    <div className="form-group">
                                                        <label>Date</label>
                                                        <DateFild
                                                            value={con.date}
                                                            onChange={(date) => setFieldValue(`contractor[${index}].date`, date)}
                                                        />
                                                    </div>
                                                </Col>
                                                <Col md={4}>
                                                    <div className="form-group">
                                                        <label>Date of Pain Onset</label>
                                                        <DateFild
                                                            value={con.dateofPainOnset}
                                                            onChange={(date) => setFieldValue(`contractor[${index}].dateofPainOnset`, date)}
                                                        />
                                                    </div>
                                                </Col>
                                                <Col md={4}>
                                                    <div className="form-group">
                                                        <label>Frequency and duration of pain</label>
                                                        <input
                                                            type="text"
                                                            name={`contractor[${index}].frequencyAndDurationofPain`}
                                                            className="form-control"
                                                            value={con.frequencyAndDurationofPain}
                                                            onChange={(e) => setFieldValue(`contractor[${index}].frequencyAndDurationofPain`, e.target.value)}
                                                        />
                                                    </div>
                                                </Col>
                                                <Col md={4}>
                                                    <div className="form-group">
                                                        <label>Gender</label>
                                                        <div className="chkgroup">
                                                            {[
                                                                "Male", "Female"
                                                            ].map((part) => (
                                                                <div className="chekbox" key={part}>
                                                                    <label>{part}
                                                                        <input
                                                                            type="checkbox"
                                                                            value={part}
                                                                            checked={con.gender?.includes(part) || false}
                                                                            onChange={(e) => {
                                                                                const selected = con.gender || [];
                                                                                const updated = e.target.checked
                                                                                    ? [...selected, part]
                                                                                    : selected.filter((p) => p !== part);
                                                                                setFieldValue(`contractor[${index}].gender`, updated);
                                                                            }}
                                                                        />
                                                                        <span className="checkmark"></span>
                                                                    </label>
                                                                </div>
                                                            ))}
                                                        </div>
                                                    </div>
                                                </Col>
                                            </Row>

                                            <div style={{ display: con.gender?.includes('Male') || con.gender?.includes('Female') ? 'block' : 'none' }}>
                                                <div className="infoboxss">
                                                    <p><b>Rt</b> = Right</p>
                                                    <p><b>Lt</b> = Left</p>
                                                </div>
                                            </div>

                                            <div style={{ display: con.gender?.includes('Male') ? 'block' : 'none' }}>
                                                <div className="painchart_Box">
                                                    <div className="chartimg">
                                                        <div className="Chartbox">
                                                            <img src={bodyL} alt="Body Left" />
                                                            <div className="leftChekList">
                                                                {[
                                                                    "Face", "Lt jaw", "Lt chest/breast", "Lt upper arm", "Lt elbow",
                                                                    "Lt lower arm", "Lt groin", "Lt wisthand/Hand", "Lt upper leg",
                                                                    "Lt knee", "Lt lower leg", "Lt ankle/foot"
                                                                ].map((part) => (
                                                                    <div className="chekbox" key={part}>
                                                                        <label>{part}
                                                                            <input
                                                                                type="checkbox"
                                                                                value={part}
                                                                                checked={con.painLocations?.includes(part) || false}
                                                                                onChange={(e) => {
                                                                                    const selected = con.painLocations || [];
                                                                                    const updated = e.target.checked
                                                                                        ? [...selected, part]
                                                                                        : selected.filter((p) => p !== part);
                                                                                    setFieldValue(`contractor[${index}].painLocations`, updated);
                                                                                }}
                                                                            />
                                                                            <span className="checkmark"></span>
                                                                        </label>
                                                                    </div>
                                                                ))}
                                                            </div>
                                                            <div className="rightChekList">
                                                                {[
                                                                    "Rt chest/breast", "Rt upper arm", "Rt elbow", "Rt lower arm",
                                                                    "Pelvis", "Rt groin", "Rt wrist/hand", "Rt upper leg",
                                                                    "Rt knee", "Rt lower leg", "Rt ankle/foot"
                                                                ].map((part) => (
                                                                    <div className="chekbox" key={part}>
                                                                        <label>{part}
                                                                            <input
                                                                                type="checkbox"
                                                                                value={part}
                                                                                checked={con.painLocations?.includes(part) || false}
                                                                                onChange={(e) => {
                                                                                    const selected = con.painLocations || [];
                                                                                    const updated = e.target.checked
                                                                                        ? [...selected, part]
                                                                                        : selected.filter((p) => p !== part);
                                                                                    setFieldValue(`contractor[${index}].painLocations`, updated);
                                                                                }}
                                                                            />
                                                                            <span className="checkmark"></span>
                                                                        </label>
                                                                    </div>
                                                                ))}
                                                            </div>
                                                        </div>

                                                        <div className="Chartbox rightimgs">
                                                            <img src={bodyR} alt="Body Right" />
                                                            <div className="leftChekList">
                                                                {[
                                                                    "Neck", "Rt shoulder", "Upper back", "Lower back",
                                                                    "Rt hip", "Rt buttocks"
                                                                ].map((part) => (
                                                                    <div className="chekbox" key={part}>
                                                                        <label>{part}
                                                                            <input
                                                                                type="checkbox"
                                                                                value={part}
                                                                                checked={con.painLocations?.includes(part) || false}
                                                                                onChange={(e) => {
                                                                                    const selected = con.painLocations || [];
                                                                                    const updated = e.target.checked
                                                                                        ? [...selected, part]
                                                                                        : selected.filter((p) => p !== part);
                                                                                    setFieldValue(`contractor[${index}].painLocations`, updated);
                                                                                }}
                                                                            />
                                                                            <span className="checkmark"></span>
                                                                        </label>
                                                                    </div>
                                                                ))}
                                                            </div>
                                                            <div className="rightChekList">
                                                                {[
                                                                    "Head", "Lt shoulder", "Li hip", "Lt buttocks"
                                                                ].map((part) => (
                                                                    <div className="chekbox" key={part}>
                                                                        <label>{part}
                                                                            <input
                                                                                type="checkbox"
                                                                                value={part}
                                                                                checked={con.painLocations?.includes(part) || false}
                                                                                onChange={(e) => {
                                                                                    const selected = con.painLocations || [];
                                                                                    const updated = e.target.checked
                                                                                        ? [...selected, part]
                                                                                        : selected.filter((p) => p !== part);
                                                                                    setFieldValue(`contractor[${index}].painLocations`, updated);
                                                                                }}
                                                                            />
                                                                            <span className="checkmark"></span>
                                                                        </label>
                                                                    </div>
                                                                ))}
                                                            </div>
                                                        </div>
                                                    </div>
                                                    {con.painLocations?.length > 0 ? (
                                                        <div className="fieldset">
                                                            <h1>Male Pain locations</h1>
                                                            <div className="selectedList">
                                                                {con.painLocations.map((loc, i) => (
                                                                    <span key={i}>{loc}</span>
                                                                ))}
                                                            </div>
                                                        </div>
                                                    ) : null}
                                                </div>

                                                <div className="form-group">
                                                    <label>Male Pain descriptions</label>
                                                    <div className="chkgroup">
                                                        {["Ache", "Burning", "Numbness", "Pins and needles", "Stabbing", "Throbbing", "Other:"].map((desc) => (
                                                            <div className="chekbox" key={desc}>
                                                                <label>{desc}
                                                                    <input
                                                                        type="checkbox"
                                                                        value={desc}
                                                                        checked={con.painDescriptions?.includes(desc) || false}
                                                                        onChange={(e) => {
                                                                            const selected = con.painDescriptions || [];
                                                                            const updated = e.target.checked
                                                                                ? [...selected, desc]
                                                                                : selected.filter(d => d !== desc);
                                                                            setFieldValue(`contractor[${index}].painDescriptions`, updated);
                                                                        }}
                                                                    />
                                                                    <span className="checkmark"></span>
                                                                </label>
                                                            </div>
                                                        ))}
                                                    </div>
                                                </div>

                                                <div className="form-group">
                                                    <label>Male Pain intensity</label>
                                                    <div className="chkgroup">
                                                        {["No pain", "1-3: Mild", "4-6: Moderate", "7-9: Severe", "10: Worst possible pain"].map((level) => (
                                                            <div className="chekbox" key={level}>
                                                                <label>{level}
                                                                    <input
                                                                        type="checkbox"
                                                                        value={level}
                                                                        checked={con.painIntensity?.includes(level) || false}
                                                                        onChange={(e) => {
                                                                            const selected = con.painIntensity || [];
                                                                            const updated = e.target.checked
                                                                                ? [...selected, level]
                                                                                : selected.filter(l => l !== level);
                                                                            setFieldValue(`contractor[${index}].painIntensity`, updated);
                                                                        }}
                                                                    />
                                                                    <span className="checkmark"></span>
                                                                </label>
                                                            </div>
                                                        ))}
                                                    </div>
                                                </div>

                                                <div className="form-group">
                                                    <label>Male Other symptoms (if any)</label>
                                                    <textarea
                                                        className="form-control"
                                                        name={`contractor[${index}].otherSymptoms`}
                                                        value={con.otherSymptoms || ''}
                                                        onChange={(e) => setFieldValue(`contractor[${index}].otherSymptoms`, e.target.value)}
                                                    />
                                                </div>
                                            </div>

                                            <div style={{ display: con.gender?.includes('Female') ? 'block' : 'none' }}>
                                                <div className="painchart_Box">
                                                    <div className="chartimg Fe">
                                                        <div className="Chartbox">
                                                            <img src={womenbodyL} alt="Body Left" />
                                                            <div className="leftChekList">
                                                                {[
                                                                    "Face", "Lt jaw", "Lt chest/breast", "Lt upper arm", "Lt elbow",
                                                                    "Lt lower arm", "Lt groin", "Lt wisthand/Hand", "Lt upper leg",
                                                                    "Lt knee", "Lt lower leg", "Lt ankle/foot"
                                                                ].map((part) => (
                                                                    <div className="chekbox" key={part}>
                                                                        <label>{part}
                                                                            <input
                                                                                type="checkbox"
                                                                                value={part}
                                                                                checked={con.FpainLocations?.includes(part) || false}
                                                                                onChange={(e) => {
                                                                                    const selected = con.FpainLocations || [];
                                                                                    const updated = e.target.checked
                                                                                        ? [...selected, part]
                                                                                        : selected.filter((p) => p !== part);
                                                                                    setFieldValue(`contractor[${index}].FpainLocations`, updated);
                                                                                }}
                                                                            />
                                                                            <span className="checkmark"></span>
                                                                        </label>
                                                                    </div>
                                                                ))}
                                                            </div>
                                                            <div className="rightChekList">
                                                                {[
                                                                    "Rt chest/breast", "Rt upper arm", "Rt elbow", "Rt lower arm",
                                                                    "Pelvis", "Rt groin", "Rt wrist/hand", "Rt upper leg",
                                                                    "Rt knee", "Rt lower leg", "Rt ankle/foot"
                                                                ].map((part) => (
                                                                    <div className="chekbox" key={part}>
                                                                        <label>{part}
                                                                            <input
                                                                                type="checkbox"
                                                                                value={part}
                                                                                checked={con.FpainLocations?.includes(part) || false}
                                                                                onChange={(e) => {
                                                                                    const selected = con.FpainLocations || [];
                                                                                    const updated = e.target.checked
                                                                                        ? [...selected, part]
                                                                                        : selected.filter((p) => p !== part);
                                                                                    setFieldValue(`contractor[${index}].FpainLocations`, updated);
                                                                                }}
                                                                            />
                                                                            <span className="checkmark"></span>
                                                                        </label>
                                                                    </div>
                                                                ))}
                                                            </div>
                                                        </div>

                                                        <div className="Chartbox rightimgs">
                                                            <img src={womenbodyR} alt="Body Right" />
                                                            <div className="leftChekList">
                                                                {[
                                                                    "Neck", "Rt shoulder", "Upper back", "Lower back",
                                                                    "Rt hip", "Rt buttocks"
                                                                ].map((part) => (
                                                                    <div className="chekbox" key={part}>
                                                                        <label>{part}
                                                                            <input
                                                                                type="checkbox"
                                                                                value={part}
                                                                                checked={con.FpainLocations?.includes(part) || false}
                                                                                onChange={(e) => {
                                                                                    const selected = con.FpainLocations || [];
                                                                                    const updated = e.target.checked
                                                                                        ? [...selected, part]
                                                                                        : selected.filter((p) => p !== part);
                                                                                    setFieldValue(`contractor[${index}].FpainLocations`, updated);
                                                                                }}
                                                                            />
                                                                            <span className="checkmark"></span>
                                                                        </label>
                                                                    </div>
                                                                ))}
                                                            </div>
                                                            <div className="rightChekList">
                                                                {[
                                                                    "Head", "Lt shoulder", "Li hip", "Lt buttocks"
                                                                ].map((part) => (
                                                                    <div className="chekbox" key={part}>
                                                                        <label>{part}
                                                                            <input
                                                                                type="checkbox"
                                                                                value={part}
                                                                                checked={con.FpainLocations?.includes(part) || false}
                                                                                onChange={(e) => {
                                                                                    const selected = con.FpainLocations || [];
                                                                                    const updated = e.target.checked
                                                                                        ? [...selected, part]
                                                                                        : selected.filter((p) => p !== part);
                                                                                    setFieldValue(`contractor[${index}].FpainLocations`, updated);
                                                                                }}
                                                                            />
                                                                            <span className="checkmark"></span>
                                                                        </label>
                                                                    </div>
                                                                ))}
                                                            </div>
                                                        </div>
                                                    </div>
                                                    {con.FpainLocations?.length > 0 ? (
                                                        <div className="fieldset">
                                                            <h1>Female Pain locations</h1>
                                                            <div className="selectedList">
                                                                {con.FpainLocations.map((loc, i) => (
                                                                    <span key={i}>{loc}</span>
                                                                ))}
                                                            </div>
                                                        </div>
                                                    ) : null}
                                                </div>

                                                <div className="form-group">
                                                    <label>Female Pain descriptions</label>
                                                    <div className="chkgroup">
                                                        {["Ache", "Burning", "Numbness", "Pins and needles", "Stabbing", "Throbbing", "Other:"].map((desc) => (
                                                            <div className="chekbox" key={desc}>
                                                                <label>{desc}
                                                                    <input
                                                                        type="checkbox"
                                                                        value={desc}
                                                                        checked={con.FpainDescriptions?.includes(desc) || false}
                                                                        onChange={(e) => {
                                                                            const selected = con.FpainDescriptions || [];
                                                                            const updated = e.target.checked
                                                                                ? [...selected, desc]
                                                                                : selected.filter(d => d !== desc);
                                                                            setFieldValue(`contractor[${index}].FpainDescriptions`, updated);
                                                                        }}
                                                                    />
                                                                    <span className="checkmark"></span>
                                                                </label>
                                                            </div>
                                                        ))}
                                                    </div>
                                                </div>

                                                <div className="form-group">
                                                    <label>Female Pain intensity</label>
                                                    <div className="chkgroup">
                                                        {["No pain", "1-3: Mild", "4-6: Moderate", "7-9: Severe", "10: Worst possible pain"].map((level) => (
                                                            <div className="chekbox" key={level}>
                                                                <label>{level}
                                                                    <input
                                                                        type="checkbox"
                                                                        value={level}
                                                                        checked={con.FpainIntensity?.includes(level) || false}
                                                                        onChange={(e) => {
                                                                            const selected = con.FpainIntensity || [];
                                                                            const updated = e.target.checked
                                                                                ? [...selected, level]
                                                                                : selected.filter(l => l !== level);
                                                                            setFieldValue(`contractor[${index}].FpainIntensity`, updated);
                                                                        }}
                                                                    />
                                                                    <span className="checkmark"></span>
                                                                </label>
                                                            </div>
                                                        ))}
                                                    </div>
                                                </div>

                                                <div className="form-group">
                                                    <label>Female Other symptoms (if any)</label>
                                                    <textarea
                                                        className="form-control"
                                                        name={`contractor[${index}].FotherSymptoms`}
                                                        value={con.FotherSymptoms || ''}
                                                        onChange={(e) => setFieldValue(`contractor[${index}].FotherSymptoms`, e.target.value)}
                                                    />
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                ))}
                            </div>

                            <div id="other" className="multiGroup" style={{ display: personInvolvedItems.includes('other') ? 'block' : 'none' }}>
                                {values.other.map((pat, index) => (
                                    <div key={`others_${index}`} className="fieldset mainFS" >
                                        <div className="statetitle_btn" >
                                            <h1 className="titles" >Other<span>{index + 1}</span></h1>
                                            <div className="addreovebtns" >
                                                <button type="button" className="btn add-btn" onClick={addOther} > +</button>
                                                {
                                                    values.other.length > 1 && (
                                                        <button type="button" className="btn remove-btn" onClick={() => removeOther(index)
                                                        }> -</button>
                                                    )}
                                            </div>
                                        </div>
                                        <div className="formsBox">
                                            <Row>
                                                <Col md={4}>
                                                    <div className="form-group">
                                                        <label>Patient's name</label>
                                                        <input
                                                            type="text"
                                                            name={`other[${index}].patientName`}
                                                            className="form-control"
                                                            value={pat.patientName}
                                                            onChange={(e) => setFieldValue(`other[${index}].patientName`, e.target.value)}
                                                        />
                                                    </div>
                                                </Col>
                                                <Col md={4}>
                                                    <div className="form-group">
                                                        <label>Patient's identity</label>
                                                        <input
                                                            type="text"
                                                            name={`other[${index}].patientIdentit`}
                                                            className="form-control"
                                                            value={pat.patientIdentit}
                                                            onChange={(e) => setFieldValue(`other[${index}].patientIdentit`, e.target.value)}
                                                        />
                                                    </div>
                                                </Col>
                                                <Col md={4}>
                                                    <div className="form-group">
                                                        <label>Date</label>
                                                        <DateFild
                                                            value={pat.date}
                                                            onChange={(date) => setFieldValue(`other[${index}].date`, date)}
                                                        />
                                                    </div>
                                                </Col>
                                                <Col md={4}>
                                                    <div className="form-group">
                                                        <label>Date of Pain Onset</label>
                                                        <DateFild
                                                            value={pat.dateofPainOnset}
                                                            onChange={(date) => setFieldValue(`other[${index}].dateofPainOnset`, date)}
                                                        />
                                                    </div>
                                                </Col>
                                                <Col md={4}>
                                                    <div className="form-group">
                                                        <label>Frequency and duration of pain</label>
                                                        <input
                                                            type="text"
                                                            name={`other[${index}].frequencyAndDurationofPain`}
                                                            className="form-control"
                                                            value={pat.frequencyAndDurationofPain}
                                                            onChange={(e) => setFieldValue(`other[${index}].frequencyAndDurationofPain`, e.target.value)}
                                                        />
                                                    </div>
                                                </Col>
                                                <Col md={4}>
                                                    <div className="form-group">
                                                        <label>Gender</label>
                                                        <div className="chkgroup">
                                                            {[
                                                                "Male", "Female"
                                                            ].map((part) => (
                                                                <div className="chekbox" key={part}>
                                                                    <label>{part}
                                                                        <input
                                                                            type="checkbox"
                                                                            value={part}
                                                                            checked={pat.gender?.includes(part) || false}
                                                                            onChange={(e) => {
                                                                                const selected = pat.gender || [];
                                                                                const updated = e.target.checked
                                                                                    ? [...selected, part]
                                                                                    : selected.filter((p) => p !== part);
                                                                                setFieldValue(`other[${index}].gender`, updated);
                                                                            }}
                                                                        />
                                                                        <span className="checkmark"></span>
                                                                    </label>
                                                                </div>
                                                            ))}
                                                        </div>
                                                    </div>
                                                </Col>
                                            </Row>

                                            <div style={{ display: pat.gender?.includes('Male') || pat.gender?.includes('Female') ? 'block' : 'none' }}>
                                                <div className="infoboxss">
                                                    <p><b>Rt</b> = Right</p>
                                                    <p><b>Lt</b> = Left</p>
                                                </div>
                                            </div>

                                            <div style={{ display: pat.gender?.includes('Male') ? 'block' : 'none' }}>
                                                <div className="painchart_Box">
                                                    <div className="chartimg">
                                                        <div className="Chartbox">
                                                            <img src={bodyL} alt="Body Left" />
                                                            <div className="leftChekList">
                                                                {[
                                                                    "Face", "Lt jaw", "Lt chest/breast", "Lt upper arm", "Lt elbow",
                                                                    "Lt lower arm", "Lt groin", "Lt wisthand/Hand", "Lt upper leg",
                                                                    "Lt knee", "Lt lower leg", "Lt ankle/foot"
                                                                ].map((part) => (
                                                                    <div className="chekbox" key={part}>
                                                                        <label>{part}
                                                                            <input
                                                                                type="checkbox"
                                                                                value={part}
                                                                                checked={pat.painLocations?.includes(part) || false}
                                                                                onChange={(e) => {
                                                                                    const selected = pat.painLocations || [];
                                                                                    const updated = e.target.checked
                                                                                        ? [...selected, part]
                                                                                        : selected.filter((p) => p !== part);
                                                                                    setFieldValue(`other[${index}].painLocations`, updated);
                                                                                }}
                                                                            />
                                                                            <span className="checkmark"></span>
                                                                        </label>
                                                                    </div>
                                                                ))}
                                                            </div>
                                                            <div className="rightChekList">
                                                                {[
                                                                    "Rt chest/breast", "Rt upper arm", "Rt elbow", "Rt lower arm",
                                                                    "Pelvis", "Rt groin", "Rt wrist/hand", "Rt upper leg",
                                                                    "Rt knee", "Rt lower leg", "Rt ankle/foot"
                                                                ].map((part) => (
                                                                    <div className="chekbox" key={part}>
                                                                        <label>{part}
                                                                            <input
                                                                                type="checkbox"
                                                                                value={part}
                                                                                checked={pat.painLocations?.includes(part) || false}
                                                                                onChange={(e) => {
                                                                                    const selected = pat.painLocations || [];
                                                                                    const updated = e.target.checked
                                                                                        ? [...selected, part]
                                                                                        : selected.filter((p) => p !== part);
                                                                                    setFieldValue(`other[${index}].painLocations`, updated);
                                                                                }}
                                                                            />
                                                                            <span className="checkmark"></span>
                                                                        </label>
                                                                    </div>
                                                                ))}
                                                            </div>
                                                        </div>

                                                        <div className="Chartbox rightimgs">
                                                            <img src={bodyR} alt="Body Right" />
                                                            <div className="leftChekList">
                                                                {[
                                                                    "Neck", "Rt shoulder", "Upper back", "Lower back",
                                                                    "Rt hip", "Rt buttocks"
                                                                ].map((part) => (
                                                                    <div className="chekbox" key={part}>
                                                                        <label>{part}
                                                                            <input
                                                                                type="checkbox"
                                                                                value={part}
                                                                                checked={pat.painLocations?.includes(part) || false}
                                                                                onChange={(e) => {
                                                                                    const selected = pat.painLocations || [];
                                                                                    const updated = e.target.checked
                                                                                        ? [...selected, part]
                                                                                        : selected.filter((p) => p !== part);
                                                                                    setFieldValue(`other[${index}].painLocations`, updated);
                                                                                }}
                                                                            />
                                                                            <span className="checkmark"></span>
                                                                        </label>
                                                                    </div>
                                                                ))}
                                                            </div>
                                                            <div className="rightChekList">
                                                                {[
                                                                    "Head", "Lt shoulder", "Li hip", "Lt buttocks"
                                                                ].map((part) => (
                                                                    <div className="chekbox" key={part}>
                                                                        <label>{part}
                                                                            <input
                                                                                type="checkbox"
                                                                                value={part}
                                                                                checked={pat.painLocations?.includes(part) || false}
                                                                                onChange={(e) => {
                                                                                    const selected = pat.painLocations || [];
                                                                                    const updated = e.target.checked
                                                                                        ? [...selected, part]
                                                                                        : selected.filter((p) => p !== part);
                                                                                    setFieldValue(`other[${index}].painLocations`, updated);
                                                                                }}
                                                                            />
                                                                            <span className="checkmark"></span>
                                                                        </label>
                                                                    </div>
                                                                ))}
                                                            </div>
                                                        </div>
                                                    </div>
                                                    {pat.painLocations?.length > 0 ? (
                                                        <div className="fieldset">
                                                            <h1>Male Pain locations</h1>
                                                            <div className="selectedList">
                                                                {pat.painLocations.map((loc, i) => (
                                                                    <span key={i}>{loc}</span>
                                                                ))}
                                                            </div>
                                                        </div>
                                                    ) : null}
                                                </div>

                                                <div className="form-group">
                                                    <label>Male Pain descriptions</label>
                                                    <div className="chkgroup">
                                                        {["Ache", "Burning", "Numbness", "Pins and needles", "Stabbing", "Throbbing", "Other:"].map((desc) => (
                                                            <div className="chekbox" key={desc}>
                                                                <label>{desc}
                                                                    <input
                                                                        type="checkbox"
                                                                        value={desc}
                                                                        checked={pat.painDescriptions?.includes(desc) || false}
                                                                        onChange={(e) => {
                                                                            const selected = pat.painDescriptions || [];
                                                                            const updated = e.target.checked
                                                                                ? [...selected, desc]
                                                                                : selected.filter(d => d !== desc);
                                                                            setFieldValue(`other[${index}].painDescriptions`, updated);
                                                                        }}
                                                                    />
                                                                    <span className="checkmark"></span>
                                                                </label>
                                                            </div>
                                                        ))}
                                                    </div>
                                                </div>

                                                <div className="form-group">
                                                    <label>Male Pain intensity</label>
                                                    <div className="chkgroup">
                                                        {["No pain", "1-3: Mild", "4-6: Moderate", "7-9: Severe", "10: Worst possible pain"].map((level) => (
                                                            <div className="chekbox" key={level}>
                                                                <label>{level}
                                                                    <input
                                                                        type="checkbox"
                                                                        value={level}
                                                                        checked={pat.painIntensity?.includes(level) || false}
                                                                        onChange={(e) => {
                                                                            const selected = pat.painIntensity || [];
                                                                            const updated = e.target.checked
                                                                                ? [...selected, level]
                                                                                : selected.filter(l => l !== level);
                                                                            setFieldValue(`other[${index}].painIntensity`, updated);
                                                                        }}
                                                                    />
                                                                    <span className="checkmark"></span>
                                                                </label>
                                                            </div>
                                                        ))}
                                                    </div>
                                                </div>

                                                <div className="form-group">
                                                    <label>Male Other symptoms (if any)</label>
                                                    <textarea
                                                        className="form-control"
                                                        name={`other[${index}].otherSymptoms`}
                                                        value={pat.otherSymptoms || ''}
                                                        onChange={(e) => setFieldValue(`other[${index}].otherSymptoms`, e.target.value)}
                                                    />
                                                </div>
                                            </div>

                                            <div style={{ display: pat.gender?.includes('Female') ? 'block' : 'none' }}>
                                                <div className="painchart_Box">
                                                    <div className="chartimg Fe">
                                                        <div className="Chartbox">
                                                            <img src={womenbodyL} alt="Body Left" />
                                                            <div className="leftChekList">
                                                                {[
                                                                    "Face", "Lt jaw", "Lt chest/breast", "Lt upper arm", "Lt elbow",
                                                                    "Lt lower arm", "Lt groin", "Lt wisthand/Hand", "Lt upper leg",
                                                                    "Lt knee", "Lt lower leg", "Lt ankle/foot"
                                                                ].map((part) => (
                                                                    <div className="chekbox" key={part}>
                                                                        <label>{part}
                                                                            <input
                                                                                type="checkbox"
                                                                                value={part}
                                                                                checked={pat.FpainLocations?.includes(part) || false}
                                                                                onChange={(e) => {
                                                                                    const selected = pat.FpainLocations || [];
                                                                                    const updated = e.target.checked
                                                                                        ? [...selected, part]
                                                                                        : selected.filter((p) => p !== part);
                                                                                    setFieldValue(`other[${index}].FpainLocations`, updated);
                                                                                }}
                                                                            />
                                                                            <span className="checkmark"></span>
                                                                        </label>
                                                                    </div>
                                                                ))}
                                                            </div>
                                                            <div className="rightChekList">
                                                                {[
                                                                    "Rt chest/breast", "Rt upper arm", "Rt elbow", "Rt lower arm",
                                                                    "Pelvis", "Rt groin", "Rt wrist/hand", "Rt upper leg",
                                                                    "Rt knee", "Rt lower leg", "Rt ankle/foot"
                                                                ].map((part) => (
                                                                    <div className="chekbox" key={part}>
                                                                        <label>{part}
                                                                            <input
                                                                                type="checkbox"
                                                                                value={part}
                                                                                checked={pat.FpainLocations?.includes(part) || false}
                                                                                onChange={(e) => {
                                                                                    const selected = pat.FpainLocations || [];
                                                                                    const updated = e.target.checked
                                                                                        ? [...selected, part]
                                                                                        : selected.filter((p) => p !== part);
                                                                                    setFieldValue(`other[${index}].FpainLocations`, updated);
                                                                                }}
                                                                            />
                                                                            <span className="checkmark"></span>
                                                                        </label>
                                                                    </div>
                                                                ))}
                                                            </div>
                                                        </div>

                                                        <div className="Chartbox rightimgs">
                                                            <img src={womenbodyR} alt="Body Right" />
                                                            <div className="leftChekList">
                                                                {[
                                                                    "Neck", "Rt shoulder", "Upper back", "Lower back",
                                                                    "Rt hip", "Rt buttocks"
                                                                ].map((part) => (
                                                                    <div className="chekbox" key={part}>
                                                                        <label>{part}
                                                                            <input
                                                                                type="checkbox"
                                                                                value={part}
                                                                                checked={pat.FpainLocations?.includes(part) || false}
                                                                                onChange={(e) => {
                                                                                    const selected = pat.FpainLocations || [];
                                                                                    const updated = e.target.checked
                                                                                        ? [...selected, part]
                                                                                        : selected.filter((p) => p !== part);
                                                                                    setFieldValue(`other[${index}].FpainLocations`, updated);
                                                                                }}
                                                                            />
                                                                            <span className="checkmark"></span>
                                                                        </label>
                                                                    </div>
                                                                ))}
                                                            </div>
                                                            <div className="rightChekList">
                                                                {[
                                                                    "Head", "Lt shoulder", "Li hip", "Lt buttocks"
                                                                ].map((part) => (
                                                                    <div className="chekbox" key={part}>
                                                                        <label>{part}
                                                                            <input
                                                                                type="checkbox"
                                                                                value={part}
                                                                                checked={pat.FpainLocations?.includes(part) || false}
                                                                                onChange={(e) => {
                                                                                    const selected = pat.FpainLocations || [];
                                                                                    const updated = e.target.checked
                                                                                        ? [...selected, part]
                                                                                        : selected.filter((p) => p !== part);
                                                                                    setFieldValue(`other[${index}].FpainLocations`, updated);
                                                                                }}
                                                                            />
                                                                            <span className="checkmark"></span>
                                                                        </label>
                                                                    </div>
                                                                ))}
                                                            </div>
                                                        </div>
                                                    </div>
                                                    {pat.FpainLocations?.length > 0 ? (
                                                        <div className="fieldset">
                                                            <h1>Female Pain locations</h1>
                                                            <div className="selectedList">
                                                                {pat.FpainLocations.map((loc, i) => (
                                                                    <span key={i}>{loc}</span>
                                                                ))}
                                                            </div>
                                                        </div>
                                                    ) : null}
                                                </div>

                                                <div className="form-group">
                                                    <label>Female Pain descriptions</label>
                                                    <div className="chkgroup">
                                                        {["Ache", "Burning", "Numbness", "Pins and needles", "Stabbing", "Throbbing", "Other:"].map((desc) => (
                                                            <div className="chekbox" key={desc}>
                                                                <label>{desc}
                                                                    <input
                                                                        type="checkbox"
                                                                        value={desc}
                                                                        checked={pat.FpainDescriptions?.includes(desc) || false}
                                                                        onChange={(e) => {
                                                                            const selected = pat.FpainDescriptions || [];
                                                                            const updated = e.target.checked
                                                                                ? [...selected, desc]
                                                                                : selected.filter(d => d !== desc);
                                                                            setFieldValue(`other[${index}].FpainDescriptions`, updated);
                                                                        }}
                                                                    />
                                                                    <span className="checkmark"></span>
                                                                </label>
                                                            </div>
                                                        ))}
                                                    </div>
                                                </div>

                                                <div className="form-group">
                                                    <label>Female Pain intensity</label>
                                                    <div className="chkgroup">
                                                        {["No pain", "1-3: Mild", "4-6: Moderate", "7-9: Severe", "10: Worst possible pain"].map((level) => (
                                                            <div className="chekbox" key={level}>
                                                                <label>{level}
                                                                    <input
                                                                        type="checkbox"
                                                                        value={level}
                                                                        checked={pat.FpainIntensity?.includes(level) || false}
                                                                        onChange={(e) => {
                                                                            const selected = pat.FpainIntensity || [];
                                                                            const updated = e.target.checked
                                                                                ? [...selected, level]
                                                                                : selected.filter(l => l !== level);
                                                                            setFieldValue(`other[${index}].FpainIntensity`, updated);
                                                                        }}
                                                                    />
                                                                    <span className="checkmark"></span>
                                                                </label>
                                                            </div>
                                                        ))}
                                                    </div>
                                                </div>

                                                <div className="form-group">
                                                    <label>Female Other symptoms (if any)</label>
                                                    <textarea
                                                        className="form-control"
                                                        name={`other[${index}].FotherSymptoms`}
                                                        value={pat.FotherSymptoms || ''}
                                                        onChange={(e) => setFieldValue(`other[${index}].FotherSymptoms`, e.target.value)}
                                                    />
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                ))}
                            </div>
                        </div>

                        {subChkLists.includes(37) && (
                            <div className="fieldset">
                                <h1>Collision</h1>
                                <div className='formsBox'>
                                    <Row>
                                        <Col md={4}>
                                            <div className="form-group">
                                                <label>Collision Type</label>
                                                <SelectFild
                                                    Firstop='Select'
                                                    selectName="collisionType"
                                                    options={[
                                                        { name: 'Moving vs. Stationary', id: 'Moving vs. Stationary' },
                                                        { name: 'Reversing', id: 'Reversing' },
                                                        { name: 'Head-on', id: 'Head-on' },
                                                        { name: 'Side-swipe', id: 'Side-swipe' },
                                                    ]}
                                                    value={values.collision.collisionType}
                                                    onChange={(selectedOption) => setFieldValue("collision.collisionType", selectedOption?.value || "")}
                                                    onBlur={handleBlur}
                                                />
                                            </div>
                                        </Col>
                                        <Col md={4}>
                                            <div className="form-group">
                                                <label>Damage Description</label>
                                                <input
                                                    type='text'
                                                    name="damageDescription"
                                                    className="form-control"
                                                    autoComplete='off'
                                                    value={values.collision.damageDescription}
                                                    onChange={(e) => setFieldValue('collision.damageDescription', e.target.value)}
                                                />
                                            </div>
                                        </Col>
                                        <Col md={4}>
                                            <div className="form-group">
                                                <label>Any Fluids Spilled</label>
                                                <SelectFild
                                                    Firstop='Select'
                                                    selectName="anyFluidsSpilled"
                                                    options={[
                                                        { name: 'fuel', id: 'fuel' },
                                                        { name: 'oil', id: 'oil' },
                                                    ]}
                                                    value={values.collision.anyFluidsSpilled}
                                                    onChange={(selectedOption) => setFieldValue("collision.anyFluidsSpilled", selectedOption?.value || "")}
                                                    onBlur={handleBlur}
                                                />
                                            </div>
                                        </Col>
                                        <Col md={4}>
                                            <div className="form-group">
                                                <label>Tow Truck Required?</label>
                                                <SelectFild
                                                    Firstop='Select'
                                                    selectName="towTruckRequired"
                                                    options={[
                                                        { name: 'No', id: 'No' },
                                                        { name: 'Yes', id: 'Yes' },
                                                    ]}
                                                    value={values.collision.towTruckRequired}
                                                    onChange={(selectedOption) => setFieldValue("collision.towTruckRequired", selectedOption?.value || "")}
                                                    onBlur={handleBlur}
                                                />
                                            </div>
                                        </Col>
                                    </Row>
                                </div>
                            </div>
                        )}

                        {subChkLists.includes(38) && (
                            <div className="fieldset">
                                <h1>Pedestrian</h1>
                                <div className='formsBox'>
                                    <Row>
                                        <Col md={4}>
                                            <div className="form-group">
                                                <label>Pedestrian Name</label>
                                                <input
                                                    type='text'
                                                    name="pedestrianName"
                                                    className="form-control"
                                                    autoComplete='off'
                                                    value={values.pedestrian.pedestrianName}
                                                    onChange={(e) => setFieldValue('pedestrian.pedestrianName', e.target.value)}
                                                />
                                            </div>
                                        </Col>
                                        <Col md={4}>
                                            <div className="form-group">
                                                <label>Pedestrian Contact</label>
                                                <input
                                                    type='text'
                                                    name="pedestrianContact"
                                                    className="form-control"
                                                    autoComplete='off'
                                                    value={values.pedestrian.pedestrianContact}
                                                    onChange={(e) => setFieldValue('pedestrian.pedestrianContact', e.target.value)}
                                                />
                                            </div>
                                        </Col>
                                        <Col md={4}>
                                            <div className="form-group">
                                                <label>Was The Area Adequately Lit?</label>
                                                <SelectFild
                                                    Firstop='Select'
                                                    selectName="wasTheAreaAdequatelyLit"
                                                    options={[
                                                        { name: 'No', id: 'No' },
                                                        { name: 'Yes', id: 'Yes' },
                                                    ]}
                                                    value={values.pedestrian.wasTheAreaAdequatelyLit}
                                                    onChange={(selectedOption) => setFieldValue("pedestrian.wasTheAreaAdequatelyLit", selectedOption?.value || "")}
                                                    onBlur={handleBlur}
                                                />
                                            </div>
                                        </Col>
                                    </Row>
                                </div>
                            </div>
                        )}

                        {subChkLists.includes(39) && (
                            <div className="fieldset">
                                <h1>Fire</h1>
                                <div className='formsBox'>
                                    <Row>
                                        <Col md={4}>
                                            <div className="form-group">
                                                <label>Fire Location</label>
                                                <SelectFild
                                                    Firstop='Select'
                                                    selectName="fireLocation"
                                                    options={[
                                                        { name: 'Engine compartment', id: 'Engine compartment' },
                                                        { name: 'Cabin', id: 'Cabin' },
                                                        { name: 'External', id: 'External' },
                                                    ]}
                                                    value={values.fire.fireLocation}
                                                    onChange={(selectedOption) => setFieldValue("fire.fireLocation", selectedOption?.value || "")}
                                                    onBlur={handleBlur}
                                                />
                                            </div>
                                        </Col>
                                        <Col md={4}>
                                            <div className="form-group">
                                                <label>Fire Alarm Activated</label>
                                                <SelectFild
                                                    Firstop='Select'
                                                    selectName="fireAlarmActivated"
                                                    options={[
                                                        { name: 'No', id: 'No' },
                                                        { name: 'Yes', id: 'Yes' },
                                                    ]}
                                                    value={values.fire.fireAlarmActivated}
                                                    onChange={(selectedOption) => setFieldValue("fire.fireAlarmActivated", selectedOption?.value || "")}
                                                    onBlur={handleBlur}
                                                />
                                            </div>
                                        </Col>
                                        <Col md={4}>
                                            <div className="form-group">
                                                <label>Fire Extinguished Before Arrival</label>
                                                <SelectFild
                                                    Firstop='Select'
                                                    selectName="fireExtinguishedBeforeArrival"
                                                    options={[
                                                        { name: 'No', id: 'No' },
                                                        { name: 'Yes', id: 'Yes' },
                                                    ]}
                                                    value={values.fire.fireExtinguishedBeforeArrival}
                                                    onChange={(selectedOption) => setFieldValue("fire.fireExtinguishedBeforeArrival", selectedOption?.value || "")}
                                                    onBlur={handleBlur}
                                                />
                                            </div>
                                        </Col>
                                        <Col md={4}>
                                            <div className="form-group">
                                                <label>Fire Service Called</label>
                                                <SelectFild
                                                    Firstop='Select'
                                                    selectName="fireServiceCalled"
                                                    options={[
                                                        { name: 'No', id: 'No' },
                                                        { name: 'Yes', id: 'Yes' },
                                                    ]}
                                                    value={values.fire.fireServiceCalled}
                                                    onChange={(selectedOption) => setFieldValue("fire.fireServiceCalled", selectedOption?.value || "")}
                                                    onBlur={handleBlur}
                                                />
                                            </div>
                                        </Col>
                                        <Col md={4}>
                                            <div className="form-group">
                                                <label>Suspected Cause</label>
                                                <SelectFild
                                                    Firstop='Select'
                                                    selectName="suspectedCause"
                                                    options={[
                                                        { name: 'No', id: 'No' },
                                                        { name: 'Yes', id: 'Yes' },
                                                    ]}
                                                    value={values.fire.suspectedCause}
                                                    onChange={(selectedOption) => setFieldValue("fire.suspectedCause", selectedOption?.value || "")}
                                                    onBlur={handleBlur}
                                                />
                                            </div>
                                        </Col>
                                    </Row>
                                </div>
                            </div>
                        )}

                        <div className="form-group">
                            <label>Remark</label>
                            <textarea
                                name="remark"
                                className="form-control"
                                autoComplete='off'
                                value={values.remark}
                                onChange={(e) => setFieldValue('remark', e.target.value)}
                            />
                        </div>

                        <UploadWithSignature onFilesChange={setUploadedFiles} />

                        <div className='previewsimges'>
                            {preImg.map((fileUrl, index) => {
                                if (fileUrl.toLowerCase().endsWith('.pdf')) {
                                    return (
                                        <div key={index} className='imageboxs'>
                                            <div className='imgs pdfs'>
                                                <div>
                                                    <div className="pdf-icon">
                                                        <FaFilePdf size={48} color="#e74c3c" />
                                                    </div>
                                                    <a href={fileUrl} target="_blank" className='btn btn-orange' rel="noopener noreferrer">view Pdf</a>
                                                </div>

                                            </div>
                                        </div>
                                    );
                                }
                                return (
                                    <div key={index} className='imageboxs'>
                                        <div className='imgs'>
                                            <img src={fileUrl} alt={`Image ${index + 1}`} />
                                        </div>
                                    </div>
                                );
                            })}
                        </div>

                        <div className='button-boxs grid pt-2 pb-2'>
                            <button type='submit' className='btn btn-orange'>Submit</button>
                        </div>
                    </form>
                </div>
            </div>
            {isLoadings ? <Loader /> : null}
        </>
    );
}

export default CarParkCurbsideIncident